"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.breakpoints = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

// l=large; m=medium; ns=not-small; s=small; xl=extra-large
var breakpoints = {
  l: '@media screen and (min-width: 60em)',
  m: '@media screen and (min-width: 30em) and (max-width: 60em)',
  ns: '@media screen and (min-width: 30em)',
  s: '@media screen and (max-width: 30em)',
  xl: '@media screen and (min-width: 90em)'
};
exports.breakpoints = breakpoints;
var _default = {
  'aspect-ratio': {
    height: '0',
    position: 'relative'
  },
  'aspect-ratio--16x9': {
    'padding-bottom': '56.25%'
  },
  'aspect-ratio--9x16': {
    'padding-bottom': '177.77%'
  },
  'aspect-ratio--4x3': {
    'padding-bottom': '75%'
  },
  'aspect-ratio--3x4': {
    'padding-bottom': '133.33%'
  },
  'aspect-ratio--6x4': {
    'padding-bottom': '66.6%'
  },
  'aspect-ratio--4x6': {
    'padding-bottom': '150%'
  },
  'aspect-ratio--8x5': {
    'padding-bottom': '62.5%'
  },
  'aspect-ratio--5x8': {
    'padding-bottom': '160%'
  },
  'aspect-ratio--7x5': {
    'padding-bottom': '71.42%'
  },
  'aspect-ratio--5x7': {
    'padding-bottom': '140%'
  },
  'aspect-ratio--1x1': {
    'padding-bottom': '100%'
  },
  'aspect-ratio--object': {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '100%',
    'z-index': '100'
  },
  'bg-center': {
    'background-repeat': 'no-repeat',
    'background-position': 'center center'
  },
  'bg-top': {
    'background-repeat': 'no-repeat',
    'background-position': 'top center'
  },
  'bg-right': {
    'background-repeat': 'no-repeat',
    'background-position': 'center right'
  },
  'bg-bottom': {
    'background-repeat': 'no-repeat',
    'background-position': 'bottom center'
  },
  'bg-left': {
    'background-repeat': 'no-repeat',
    'background-position': 'center left'
  },
  cover: {
    'background-size': 'cover'
  },
  contain: {
    'background-size': 'contain'
  },
  'b--black': {
    'border-color': 'var(--black)'
  },
  'b--near-black': {
    'border-color': 'var(--near-black)'
  },
  'b--dark-gray': {
    'border-color': 'var(--dark-gray)'
  },
  'b--mid-gray': {
    'border-color': 'var(--mid-gray)'
  },
  'b--gray': {
    'border-color': 'var(--gray)'
  },
  'b--light-gray': {
    'border-color': 'var(--light-gray)'
  },
  'b--near-white': {
    'border-color': 'var(--near-white)'
  },
  'b--white': {
    'border-color': 'var(--white)'
  },
  'b--white-90': {
    'border-color': 'var(--white-90)'
  },
  'b--white-80': {
    'border-color': 'var(--white-80)'
  },
  'b--white-70': {
    'border-color': 'var(--white-70)'
  },
  'b--white-60': {
    'border-color': 'var(--white-60)'
  },
  'b--white-50': {
    'border-color': 'var(--white-50)'
  },
  'b--white-40': {
    'border-color': 'var(--white-40)'
  },
  'b--white-30': {
    'border-color': 'var(--white-30)'
  },
  'b--white-20': {
    'border-color': 'var(--white-20)'
  },
  'b--white-10': {
    'border-color': 'var(--white-10)'
  },
  'b--white-05': {
    'border-color': 'var(--white-05)'
  },
  'b--white-025': {
    'border-color': 'var(--white-025)'
  },
  'b--white-0125': {
    'border-color': 'var(--white-0125)'
  },
  'b--black-90': {
    'border-color': 'var(--black-90)'
  },
  'b--black-80': {
    'border-color': 'var(--black-80)'
  },
  'b--black-70': {
    'border-color': 'var(--black-70)'
  },
  'b--black-60': {
    'border-color': 'var(--black-60)'
  },
  'b--black-50': {
    'border-color': 'var(--black-50)'
  },
  'b--black-40': {
    'border-color': 'var(--black-40)'
  },
  'b--black-30': {
    'border-color': 'var(--black-30)'
  },
  'b--black-20': {
    'border-color': 'var(--black-20)'
  },
  'b--black-10': {
    'border-color': 'var(--black-10)'
  },
  'b--black-05': {
    'border-color': 'var(--black-05)'
  },
  'b--black-025': {
    'border-color': 'var(--black-025)'
  },
  'b--black-0125': {
    'border-color': 'var(--black-0125)'
  },
  'b--dark-red': {
    'border-color': 'var(--dark-red)'
  },
  'b--red': {
    'border-color': 'var(--red)'
  },
  'b--light-red': {
    'border-color': 'var(--light-red)'
  },
  'b--orange': {
    'border-color': 'var(--orange)'
  },
  'b--dark-orange': {
    'border-color': 'var(--dark-orange)'
  },
  'b--gold': {
    'border-color': 'var(--gold)'
  },
  'b--yellow': {
    'border-color': 'var(--yellow)'
  },
  'b--light-yellow': {
    'border-color': 'var(--light-yellow)'
  },
  'b--green': {
    'border-color': 'var(--green)'
  },
  'b--light-green': {
    'border-color': 'var(--light-green)'
  },
  'b--navy': {
    'border-color': 'var(--navy)'
  },
  'b--dark-blue': {
    'border-color': 'var(--dark-blue)'
  },
  'b--blue': {
    'border-color': 'var(--blue)'
  },
  'b--alice-blue': {
    'border-color': 'var(--alice-blue)'
  },
  'b--pacific-blue': {
    'border-color': 'var(--pacific-blue)'
  },
  'b--light-blue': {
    'border-color': 'var(--light-blue)'
  },
  'b--lightest-blue': {
    'border-color': 'var(--lightest-blue)'
  },
  'b--washed-blue': {
    'border-color': 'var(--washed-blue)'
  },
  'b--transparent': {
    'border-color': 'var(--transparent)'
  },
  br0: {
    'border-radius': '0'
  },
  br1: {
    'border-radius': '.125rem'
  },
  br2: {
    'border-radius': '.25rem'
  },
  br3: {
    'border-radius': '.5rem'
  },
  br4: {
    'border-radius': '1rem'
  },
  'br-100': {
    'border-radius': '100%'
  },
  'br-pill': {
    'border-radius': '9999px'
  },
  'br--bottom': {
    'border-top-left-radius': '0',
    'border-top-right-radius': '0'
  },
  'br--top': {
    'border-bottom-left-radius': '0',
    'border-bottom-right-radius': '0'
  },
  'br--right': {
    'border-top-left-radius': '0',
    'border-bottom-left-radius': '0'
  },
  'br--left': {
    'border-top-right-radius': '0',
    'border-bottom-right-radius': '0'
  },
  'b--dotted': {
    'border-style': 'dotted'
  },
  'b--dashed': {
    'border-style': 'dashed'
  },
  'b--solid': {
    'border-style': 'solid'
  },
  'b--none': {
    'border-style': 'none'
  },
  bw0: {
    'border-width': '0'
  },
  bw1: {
    'border-width': '.125rem'
  },
  bw2: {
    'border-width': '.25rem'
  },
  bw3: {
    'border-width': '.5rem'
  },
  bw4: {
    'border-width': '1rem'
  },
  bw5: {
    'border-width': '2rem'
  },
  'bt-0': {
    'border-top-width': '0'
  },
  'br-0': {
    'border-right-width': '0'
  },
  'bb-0': {
    'border-bottom-width': '0'
  },
  'bl-0': {
    'border-left-width': '0'
  },
  ba: {
    'border-style': 'solid',
    'border-width': '1px'
  },
  bt: {
    'border-top-style': 'solid',
    'border-top-width': '1px'
  },
  br: {
    'border-right-style': 'solid',
    'border-right-width': '1px'
  },
  bb: {
    'border-bottom-style': 'solid',
    'border-bottom-width': '1px'
  },
  bl: {
    'border-left-style': 'solid',
    'border-left-width': '1px'
  },
  bn: {
    'border-style': 'none',
    'border-width': '0'
  },
  'shadow-0': {
    'box-shadow': 'none'
  },
  'shadow-1': {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.2 )'
  },
  'shadow-2': {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.2 )'
  },
  'shadow-3': {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.2 )'
  },
  'shadow-4': {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.2 )'
  },
  'shadow-5': {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.2 )'
  },
  'shadow-6': {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.2 )'
  },
  'shadow-light-0': {
    'box-shadow': 'none'
  },
  'shadow-light-1': {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.1 )'
  },
  'shadow-light-2': {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.1 )'
  },
  'shadow-light-3': {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.1 )'
  },
  'shadow-light-4': {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.1 )'
  },
  'shadow-light-5': {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.1 )'
  },
  'shadow-light-6': {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.1 )'
  },
  html: {
    'box-sizing': 'border-box'
  },
  body: {
    'box-sizing': 'border-box'
  },
  div: {
    'box-sizing': 'border-box'
  },
  article: {
    'box-sizing': 'border-box'
  },
  section: {
    'box-sizing': 'border-box'
  },
  main: {
    'box-sizing': 'border-box'
  },
  footer: {
    'box-sizing': 'border-box'
  },
  header: {
    'box-sizing': 'border-box'
  },
  form: {
    'box-sizing': 'border-box'
  },
  fieldset: {
    'box-sizing': 'border-box'
  },
  legend: {
    'box-sizing': 'border-box'
  },
  pre: {
    'box-sizing': 'border-box',
    'white-space': 'pre'
  },
  code: {
    'box-sizing': 'border-box',
    'font-family': 'Consolas, monaco, monospace'
  },
  p: {
    'box-sizing': 'border-box'
  },
  a: {
    'box-sizing': 'border-box'
  },
  h1: {
    'box-sizing': 'border-box',
    height: '1rem'
  },
  h2: {
    'box-sizing': 'border-box',
    height: '2rem'
  },
  h3: {
    'box-sizing': 'border-box',
    height: '4rem'
  },
  h4: {
    'box-sizing': 'border-box',
    height: '8rem'
  },
  h5: {
    'box-sizing': 'border-box',
    height: '16rem'
  },
  h6: {
    'box-sizing': 'border-box'
  },
  ul: {
    'box-sizing': 'border-box'
  },
  ol: {
    'box-sizing': 'border-box'
  },
  li: {
    'box-sizing': 'border-box'
  },
  dl: {
    'box-sizing': 'border-box'
  },
  dt: {
    'box-sizing': 'border-box',
    display: 'table'
  },
  dd: {
    'box-sizing': 'border-box'
  },
  textarea: {
    'box-sizing': 'border-box'
  },
  'input-type--email': {
    'box-sizing': 'border-box'
  },
  'input-type--number': {
    'box-sizing': 'border-box'
  },
  'input-type--password': {
    'box-sizing': 'border-box'
  },
  'input-type--tel': {
    'box-sizing': 'border-box'
  },
  'input-type--text': {
    'box-sizing': 'border-box'
  },
  'input-type--url': {
    'box-sizing': 'border-box'
  },
  'border-box': {
    'box-sizing': 'border-box'
  },
  'cf-before': {
    content: '" "',
    display: 'table'
  },
  'cf-after': {
    clear: 'both'
  },
  cf: {
    '*zoom': '1'
  },
  cl: {
    clear: 'left'
  },
  cr: {
    clear: 'right'
  },
  cb: {
    clear: 'both'
  },
  cn: {
    clear: 'none'
  },
  'top-0': {
    top: '0'
  },
  'right-0': {
    right: '0'
  },
  'bottom-0': {
    bottom: '0'
  },
  'left-0': {
    left: '0'
  },
  'top-1': {
    top: '1rem'
  },
  'right-1': {
    right: '1rem'
  },
  'bottom-1': {
    bottom: '1rem'
  },
  'left-1': {
    left: '1rem'
  },
  'top-2': {
    top: '2rem'
  },
  'right-2': {
    right: '2rem'
  },
  'bottom-2': {
    bottom: '2rem'
  },
  'left-2': {
    left: '2rem'
  },
  'top--1': {
    top: '-1rem'
  },
  'right--1': {
    right: '-1rem'
  },
  'bottom--1': {
    bottom: '-1rem'
  },
  'left--1': {
    left: '-1rem'
  },
  'top--2': {
    top: '-2rem'
  },
  'right--2': {
    right: '-2rem'
  },
  'bottom--2': {
    bottom: '-2rem'
  },
  'left--2': {
    left: '-2rem'
  },
  'absolute--fill': {
    top: '0',
    right: '0',
    bottom: '0',
    left: '0'
  },
  dn: {
    display: 'none'
  },
  di: {
    display: 'inline'
  },
  db: {
    display: 'block'
  },
  dib: {
    display: 'inline-block'
  },
  dit: {
    display: 'inline-table'
  },
  dtc: {
    display: 'table-cell'
  },
  'dt-row': {
    display: 'table-row'
  },
  'dt-row-group': {
    display: 'table-row-group'
  },
  'dt-column': {
    display: 'table-column'
  },
  'dt-column-group': {
    display: 'table-column-group'
  },
  'dt--fixed': {
    'table-layout': 'fixed',
    width: '100%'
  },
  flex: {
    display: 'flex'
  },
  'inline-flex': {
    display: 'inline-flex'
  },
  'flex-auto': {
    flex: '1 1 auto',
    'min-width': '0',
    'min-height': '0'
  },
  'flex-none': {
    flex: 'none'
  },
  'flex-column': {
    'flex-direction': 'column'
  },
  'flex-row': {
    'flex-direction': 'row'
  },
  'flex-shrink-0': {
    'flex-shrink': '0'
  },
  'flex-wrap': {
    'flex-wrap': 'wrap'
  },
  'flex-nowrap': {
    'flex-wrap': 'nowrap'
  },
  'items-start': {
    'align-items': 'flex-start'
  },
  'items-end': {
    'align-items': 'flex-end'
  },
  'items-center': {
    'align-items': 'center'
  },
  'items-baseline': {
    'align-items': 'baseline'
  },
  'items-stretch': {
    'align-items': 'stretch'
  },
  'self-start': {
    'align-self': 'flex-start'
  },
  'self-end': {
    'align-self': 'flex-end'
  },
  'self-center': {
    'align-self': 'center'
  },
  'self-baseline': {
    'align-self': 'baseline'
  },
  'self-stretch': {
    'align-self': 'stretch'
  },
  sticky: {
    position: 'sticky'
  },
  'justify-start': {
    'justify-content': 'flex-start'
  },
  'justify-end': {
    'justify-content': 'flex-end'
  },
  'justify-center': {
    'justify-content': 'center'
  },
  'justify-between': {
    'justify-content': 'space-between'
  },
  'justify-around': {
    'justify-content': 'space-around'
  },
  'content-start': {
    'align-content': 'flex-start'
  },
  'content-end': {
    'align-content': 'flex-end'
  },
  'content-center': {
    'align-content': 'center'
  },
  'content-between': {
    'align-content': 'space-between'
  },
  'content-around': {
    'align-content': 'space-around'
  },
  'content-stretch': {
    'align-content': 'stretch'
  },
  'order-0': {
    order: '0'
  },
  'order-1': {
    order: '1'
  },
  'order-2': {
    order: '2'
  },
  'order-3': {
    order: '3'
  },
  'order-4': {
    order: '4'
  },
  'order-5': {
    order: '5'
  },
  'order-6': {
    order: '6'
  },
  'order-7': {
    order: '7'
  },
  'order-8': {
    order: '8'
  },
  'order-last': {
    order: '99999'
  },
  fl: {
    "float": 'left',
    _display: 'inline'
  },
  fr: {
    "float": 'right',
    display: 'inline'
  },
  fn: {
    "float": 'none'
  },
  'sans-serif': {
    'font-family': 'var(--sans-serif)'
  },
  serif: {
    'font-family': 'var(--serif)'
  },
  i: {
    'font-style': 'italic'
  },
  'fs-normal': {
    'font-style': 'normal'
  },
  normal: {
    'font-weight': 'normal'
  },
  b: {
    'font-weight': 'bold'
  },
  fw1: {
    'font-weight': '100'
  },
  fw2: {
    'font-weight': '200'
  },
  fw3: {
    'font-weight': '300'
  },
  fw4: {
    'font-weight': '400'
  },
  fw5: {
    'font-weight': '500'
  },
  fw6: {
    'font-weight': '600'
  },
  fw7: {
    'font-weight': '700'
  },
  fw8: {
    'font-weight': '800'
  },
  fw9: {
    'font-weight': '900'
  },
  'input-reset': {
    '-webkit-appearance': 'none',
    '-moz-appearance': 'none'
  },
  'button-reset---moz-focus-inner': {
    border: '0',
    padding: '0'
  },
  'input-reset---moz-focus-inner': {
    border: '0',
    padding: '0'
  },
  'h-25': {
    height: '25%'
  },
  'h-50': {
    height: '50%'
  },
  'h-75': {
    height: '75%'
  },
  'h-100': {
    height: '100%'
  },
  'min-h-100': {
    'min-height': '100%'
  },
  'vh-25': {
    height: '25vh'
  },
  'vh-50': {
    height: '50vh'
  },
  'vh-75': {
    height: '75vh'
  },
  'vh-100': {
    height: '100vh'
  },
  'min-vh-100': {
    'min-height': '100vh'
  },
  'h-auto': {
    height: 'auto'
  },
  'h-inherit': {
    height: 'inherit'
  },
  dim: {
    opacity: '1',
    transition: 'opacity .15s ease-in'
  },
  'dim-focus': {
    opacity: '.5',
    transition: 'opacity .15s ease-in'
  },
  'dim-active': {
    opacity: '.8',
    transition: 'opacity .15s ease-out'
  },
  'hide-child--child': {
    opacity: '0',
    transition: 'opacity .15s ease-in'
  },
  'hide-child-hover--child': {
    opacity: '1',
    transition: 'opacity .15s ease-in'
  },
  'hide-child-focus--child': {
    opacity: '1',
    transition: 'opacity .15s ease-in'
  },
  'hide-child-active--child': {
    opacity: '1',
    transition: 'opacity .15s ease-in'
  },
  'underline-hover-focus': {
    'text-decoration': 'underline'
  },
  grow: {
    '-moz-osx-font-smoothing': 'grayscale',
    'backface-visibility': 'hidden',
    transform: 'translateZ(0)',
    transition: 'transform 0.25s ease-out'
  },
  'grow-focus': {
    transform: 'scale(1.05)'
  },
  'grow-active': {
    transform: 'scale(.90)'
  },
  'grow-large': {
    '-moz-osx-font-smoothing': 'grayscale',
    'backface-visibility': 'hidden',
    transform: 'translateZ(0)',
    transition: 'transform .25s ease-in-out'
  },
  'grow-large-focus': {
    transform: 'scale(1.2)'
  },
  'grow-large-active': {
    transform: 'scale(.95)'
  },
  'shadow-hover--after': {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, .2 )',
    opacity: '0',
    transition: 'opacity .25s ease-in-out'
  },
  'shadow-hover-hover--after': {
    opacity: '1'
  },
  'shadow-hover-focus--after': {
    opacity: '1'
  },
  'bg-animate': {
    transition: 'background-color .15s ease-in-out'
  },
  'bg-animate-focus': {
    transition: 'background-color .15s ease-in-out'
  },
  img: {
    'max-width': '100%'
  },
  tracked: {
    'letter-spacing': '.1em'
  },
  'tracked-tight': {
    'letter-spacing': '-.05em'
  },
  'tracked-mega': {
    'letter-spacing': '.25em'
  },
  'lh-solid': {
    'line-height': '1'
  },
  'lh-title': {
    'line-height': '1.25'
  },
  'lh-copy': {
    'line-height': '1.5'
  },
  link: {
    'text-decoration': 'none',
    transition: 'color .15s ease-in'
  },
  'link-link': {
    transition: 'color .15s ease-in'
  },
  'link-visited': {
    transition: 'color .15s ease-in'
  },
  'link-active': {
    transition: 'color .15s ease-in'
  },
  'link-focus': {
    transition: 'color .15s ease-in'
  },
  list: {
    'list-style-type': 'none'
  },
  'mw-100': {
    'max-width': '100%'
  },
  mw1: {
    'max-width': '1rem'
  },
  mw2: {
    'max-width': '2rem'
  },
  mw3: {
    'max-width': '4rem'
  },
  mw4: {
    'max-width': '8rem'
  },
  mw5: {
    'max-width': '16rem'
  },
  mw6: {
    'max-width': '32rem'
  },
  mw7: {
    'max-width': '48rem'
  },
  mw8: {
    'max-width': '64rem'
  },
  mw9: {
    'max-width': '1440px'
  },
  'mw-none': {
    'max-width': 'none'
  },
  'o-100': {
    opacity: '1'
  },
  'o-90': {
    opacity: '.9'
  },
  'o-80': {
    opacity: '.8'
  },
  'o-70': {
    opacity: '.7'
  },
  'o-60': {
    opacity: '.6'
  },
  'o-50': {
    opacity: '.5'
  },
  'o-40': {
    opacity: '.4'
  },
  'o-30': {
    opacity: '.3'
  },
  'o-20': {
    opacity: '.2'
  },
  'o-10': {
    opacity: '.1'
  },
  'o-05': {
    opacity: '.05'
  },
  'o-025': {
    opacity: '.025'
  },
  'o-0': {
    opacity: '0'
  },
  outline: {
    outline: '1px solid'
  },
  'outline-transparent': {
    outline: '1px solid transparent'
  },
  'outline-0': {
    outline: '0'
  },
  'overflow-visible': {
    overflow: 'visible'
  },
  'overflow-hidden': {
    overflow: 'hidden'
  },
  'overflow-scroll': {
    overflow: 'scroll'
  },
  'overflow-auto': {
    overflow: 'auto'
  },
  'overflow-x-visible': {
    'overflow-x': 'visible'
  },
  'overflow-x-hidden': {
    'overflow-x': 'hidden'
  },
  'overflow-x-scroll': {
    'overflow-x': 'scroll'
  },
  'overflow-x-auto': {
    'overflow-x': 'auto'
  },
  'overflow-y-visible': {
    'overflow-y': 'visible'
  },
  'overflow-y-hidden': {
    'overflow-y': 'hidden'
  },
  'overflow-y-scroll': {
    'overflow-y': 'scroll'
  },
  'overflow-y-auto': {
    'overflow-y': 'auto'
  },
  "static": {
    position: 'static'
  },
  relative: {
    position: 'relative'
  },
  absolute: {
    position: 'absolute'
  },
  fixed: {
    position: 'fixed'
  },
  'rotate-45': {
    transform: 'rotate(45deg)'
  },
  'rotate-90': {
    transform: 'rotate(90deg)'
  },
  'rotate-135': {
    transform: 'rotate(135deg)'
  },
  'rotate-180': {
    transform: 'rotate(180deg)'
  },
  'rotate-225': {
    transform: 'rotate(225deg)'
  },
  'rotate-270': {
    transform: 'rotate(270deg)'
  },
  'rotate-315': {
    transform: 'rotate(315deg)'
  },
  'black-90': {
    color: 'var(--black-90)'
  },
  'black-80': {
    color: 'var(--black-80)'
  },
  'black-70': {
    color: 'var(--black-70)'
  },
  'black-60': {
    color: 'var(--black-60)'
  },
  'black-50': {
    color: 'var(--black-50)'
  },
  'black-40': {
    color: 'var(--black-40)'
  },
  'black-30': {
    color: 'var(--black-30)'
  },
  'black-20': {
    color: 'var(--black-20)'
  },
  'black-10': {
    color: 'var(--black-10)'
  },
  'black-05': {
    color: 'var(--black-05)'
  },
  'white-90': {
    color: 'var(--white-90)'
  },
  'white-80': {
    color: 'var(--white-80)'
  },
  'white-70': {
    color: 'var(--white-70)'
  },
  'white-60': {
    color: 'var(--white-60)'
  },
  'white-50': {
    color: 'var(--white-50)'
  },
  'white-40': {
    color: 'var(--white-40)'
  },
  'white-30': {
    color: 'var(--white-30)'
  },
  'white-20': {
    color: 'var(--white-20)'
  },
  'white-10': {
    color: 'var(--white-10)'
  },
  black: {
    color: 'var(--black)'
  },
  'near-black': {
    color: 'var(--near-black)'
  },
  'dark-gray': {
    color: 'var(--dark-gray)'
  },
  'mid-gray': {
    color: 'var(--mid-gray)'
  },
  gray: {
    color: 'var(--gray)'
  },
  'light-gray': {
    color: 'var(--light-gray)'
  },
  'near-white': {
    color: 'var(--near-white)'
  },
  white: {
    color: 'var(--white)'
  },
  'dark-red': {
    color: 'var(--dark-red)'
  },
  red: {
    color: 'var(--red)'
  },
  'light-red': {
    color: 'var(--light-red)'
  },
  orange: {
    color: 'var(--orange)'
  },
  'dark-orange': {
    color: 'var(--dark-orange)'
  },
  gold: {
    color: 'var(--gold)'
  },
  yellow: {
    color: 'var(--yellow)'
  },
  'light-yellow': {
    color: 'var(--light-yellow)'
  },
  green: {
    color: 'var(--green)'
  },
  'dark-green': {
    color: 'var(--dark-green)'
  },
  'light-green': {
    color: 'var(--light-green)'
  },
  navy: {
    color: 'var(--navy)'
  },
  'dark-blue': {
    color: 'var(--dark-blue)'
  },
  blue: {
    color: 'var(--blue)'
  },
  'light-blue': {
    color: 'var(--light-blue)'
  },
  'outline-blue': {
    color: 'var(--outline-blue)'
  },
  'lightest-blue': {
    color: 'var(--lightest-blue)'
  },
  'washed-blue': {
    color: 'var(--washed-blue)'
  },
  'bg-black-90': {
    'background-color': 'var(--black-90)'
  },
  'bg-black-80': {
    'background-color': 'var(--black-80)'
  },
  'bg-black-70': {
    'background-color': 'var(--black-70)'
  },
  'bg-black-60': {
    'background-color': 'var(--black-60)'
  },
  'bg-black-50': {
    'background-color': 'var(--black-50)'
  },
  'bg-black-40': {
    'background-color': 'var(--black-40)'
  },
  'bg-black-30': {
    'background-color': 'var(--black-30)'
  },
  'bg-black-20': {
    'background-color': 'var(--black-20)'
  },
  'bg-black-10': {
    'background-color': 'var(--black-10)'
  },
  'bg-black-05': {
    'background-color': 'var(--black-05)'
  },
  'bg-white-90': {
    'background-color': 'var(--white-90)'
  },
  'bg-white-80': {
    'background-color': 'var(--white-80)'
  },
  'bg-white-70': {
    'background-color': 'var(--white-70)'
  },
  'bg-white-60': {
    'background-color': 'var(--white-60)'
  },
  'bg-white-50': {
    'background-color': 'var(--white-50)'
  },
  'bg-white-40': {
    'background-color': 'var(--white-40)'
  },
  'bg-white-30': {
    'background-color': 'var(--white-30)'
  },
  'bg-white-20': {
    'background-color': 'var(--white-20)'
  },
  'bg-white-10': {
    'background-color': 'var(--white-10)'
  },
  'bg-black': {
    'background-color': 'var(--black)'
  },
  'bg-near-black': {
    'background-color': 'var(--near-black)'
  },
  'bg-dark-gray': {
    'background-color': 'var(--dark-gray)'
  },
  'bg-mid-gray': {
    'background-color': 'var(--mid-gray)'
  },
  'bg-gray': {
    'background-color': 'var(--gray)'
  },
  'bg-light-gray': {
    'background-color': 'var(--light-gray)'
  },
  'bg-near-white': {
    'background-color': 'var(--near-white)'
  },
  'bg-white': {
    'background-color': 'var(--white)'
  },
  'bg-transparent': {
    'background-color': 'var(--transparent)'
  },
  'bg-dark-red': {
    'background-color': 'var(--dark-red)'
  },
  'bg-red': {
    'background-color': 'var(--red)'
  },
  'bg-light-red': {
    'background-color': 'var(--light-red)'
  },
  'bg-orange': {
    'background-color': 'var(--orange)'
  },
  'bg-dark-orange': {
    'background-color': 'var(--dark-orange)'
  },
  'bg-gold': {
    'background-color': 'var(--gold)'
  },
  'bg-yellow': {
    'background-color': 'var(--yellow)'
  },
  'bg-light-yellow': {
    'background-color': 'var(--light-yellow)'
  },
  'bg-green': {
    'background-color': 'var(--green)'
  },
  'bg-light-green': {
    'background-color': 'var(--light-green)'
  },
  'bg-navy': {
    'background-color': 'var(--navy)'
  },
  'bg-dark-blue': {
    'background-color': 'var(--dark-blue)'
  },
  'bg-blue': {
    'background-color': 'var(--blue)'
  },
  'bg-alice-blue': {
    'background-color': 'var(--alice-blue)'
  },
  'bg-pacific-blue': {
    'background-color': 'var(--pacific-blue)'
  },
  'bg-light-blue': {
    'background-color': 'var(--light-blue)'
  },
  'bg-lightest-blue': {
    'background-color': 'var(--lightest-blue)'
  },
  'bg-washed-blue': {
    'background-color': 'var(--washed-blue)'
  },
  'hover-black-focus': {
    color: 'var(--black)'
  },
  'hover-near-black-focus': {
    color: 'var(--near-black)'
  },
  'hover-dark-gray-focus': {
    color: 'var(--dark-gray)'
  },
  'hover-mid-gray-focus': {
    color: 'var(--mid-gray)'
  },
  'hover-gray-focus': {
    color: 'var(--gray)'
  },
  'hover-light-gray-focus': {
    color: 'var(--light-gray)'
  },
  'hover-near-white-focus': {
    color: 'var(--near-white)'
  },
  'hover-white-focus': {
    color: 'var(--white)'
  },
  'hover-bg-black-focus': {
    'background-color': 'var(--black)'
  },
  'hover-bg-near-black-focus': {
    'background-color': 'var(--near-black)'
  },
  'hover-bg-dark-gray-focus': {
    'background-color': 'var(--mid-gray)'
  },
  'hover-bg-gray-focus': {
    'background-color': 'var(--gray)'
  },
  'hover-bg-light-gray-focus': {
    'background-color': 'var(--light-gray)'
  },
  'hover-bg-near-white-focus': {
    'background-color': 'var(--near-white)'
  },
  'hover-bg-white-focus': {
    'background-color': 'var(--white)'
  },
  'hover-bg-transparent-focus': {
    'background-color': 'var(--transparent)'
  },
  'hover-dark-red-focus': {
    color: 'var(--dark-red)'
  },
  'hover-red-focus': {
    color: 'var(--red)'
  },
  'hover-light-red-focus': {
    color: 'var(--light-red)'
  },
  'hover-orange-focus': {
    color: 'var(--orange)'
  },
  'hover-dark-orange-focus': {
    color: 'var(--dark-orange)'
  },
  'hover-gold-focus': {
    color: 'var(--gold)'
  },
  'hover-yellow-focus': {
    color: 'var(--yellow)'
  },
  'hover-light-yellow-focus': {
    color: 'var(--light-yellow)'
  },
  'hover-green-focus': {
    color: 'var(--green)'
  },
  'hover-light-green-focus': {
    color: 'var(--light-green)'
  },
  'hover-navy-focus': {
    color: 'var(--navy)'
  },
  'hover-dark-blue-focus': {
    color: 'var(--dark-blue)'
  },
  'hover-blue-focus': {
    color: 'var(--blue)'
  },
  'hover-light-blue-focus': {
    color: 'var(--light-blue)'
  },
  'hover-lightest-blue-focus': {
    color: 'var(--lightest-blue)'
  },
  'hover-washed-blue-focus': {
    color: 'var(--washed-blue)'
  },
  'hover-bg-dark-red-focus': {
    'background-color': 'var(--dark-red)'
  },
  'hover-bg-red-focus': {
    'background-color': 'var(--red)'
  },
  'hover-bg-light-red-focus': {
    'background-color': 'var(--light-red)'
  },
  'hover-bg-orange-focus': {
    'background-color': 'var(--orange)'
  },
  'hover-bg-dark-orange-focus': {
    'background-color': 'var(--dark-orange)'
  },
  'hover-bg-gold-focus': {
    'background-color': 'var(--gold)'
  },
  'hover-bg-yellow-focus': {
    'background-color': 'var(--yellow)'
  },
  'hover-bg-light-yellow-focus': {
    'background-color': 'var(--light-yellow)'
  },
  'hover-bg-green-focus': {
    'background-color': 'var(--green)'
  },
  'hover-bg-light-green-focus': {
    'background-color': 'var(--light-green)'
  },
  'hover-bg-navy-focus': {
    'background-color': 'var(--navy)'
  },
  'hover-bg-dark-blue-focus': {
    'background-color': 'var(--dark-blue)'
  },
  'hover-bg-blue-focus': {
    'background-color': 'var(--blue)'
  },
  'hover-bg-light-blue-focus': {
    'background-color': 'var(--light-blue)'
  },
  'hover-bg-lightest-blue-focus': {
    'background-color': 'var(--lightest-blue)'
  },
  'hover-bg-washed-blue-focus': {
    'background-color': 'var(--washed-blue)'
  },
  na1: {
    margin: 'calc(-1 * var(--spacing-extra-small))'
  },
  na2: {
    margin: 'calc(-1 * var(--spacing-small))'
  },
  na3: {
    margin: 'calc(-1 * var(--spacing-medium))'
  },
  na4: {
    margin: 'calc(-1 * var(--spacing-large))'
  },
  na5: {
    margin: 'calc(-1 * var(--spacing-extra-large))'
  },
  na6: {
    margin: 'calc(-1 * var(--spacing-extra-extra-large))'
  },
  na7: {
    margin: 'calc(-1 * var(--spacing-extra-extra-extra-large))'
  },
  nl1: {
    'margin-left': 'calc(-1 * var(--spacing-extra-small))'
  },
  nl2: {
    'margin-left': 'calc(-1 * var(--spacing-small))'
  },
  nl3: {
    'margin-left': 'calc(-1 * var(--spacing-medium))'
  },
  nl4: {
    'margin-left': 'calc(-1 * var(--spacing-large))'
  },
  nl5: {
    'margin-left': 'calc(-1 * var(--spacing-extra-large))'
  },
  nl6: {
    'margin-left': 'calc(-1 * var(--spacing-extra-extra-large))'
  },
  nl7: {
    'margin-left': 'calc(-1 * var(--spacing-extra-extra-extra-large))'
  },
  nr1: {
    'margin-right': 'calc(-1 * var(--spacing-extra-small))'
  },
  nr2: {
    'margin-right': 'calc(-1 * var(--spacing-small))'
  },
  nr3: {
    'margin-right': 'calc(-1 * var(--spacing-medium))'
  },
  nr4: {
    'margin-right': 'calc(-1 * var(--spacing-large))'
  },
  nr5: {
    'margin-right': 'calc(-1 * var(--spacing-extra-large))'
  },
  nr6: {
    'margin-right': 'calc(-1 * var(--spacing-extra-extra-large))'
  },
  nr7: {
    'margin-right': 'calc(-1 * var(--spacing-extra-extra-extra-large))'
  },
  nb1: {
    'margin-bottom': 'calc(-1 * var(--spacing-extra-small))'
  },
  nb2: {
    'margin-bottom': 'calc(-1 * var(--spacing-small))'
  },
  nb3: {
    'margin-bottom': 'calc(-1 * var(--spacing-medium))'
  },
  nb4: {
    'margin-bottom': 'calc(-1 * var(--spacing-large))'
  },
  nb5: {
    'margin-bottom': 'calc(-1 * var(--spacing-extra-large))'
  },
  nb6: {
    'margin-bottom': 'calc(-1 * var(--spacing-extra-extra-large))'
  },
  nb7: {
    'margin-bottom': 'calc(-1 * var(--spacing-extra-extra-extra-large))'
  },
  nt1: {
    'margin-top': 'calc(-1 * var(--spacing-extra-small))'
  },
  nt2: {
    'margin-top': 'calc(-1 * var(--spacing-small))'
  },
  nt3: {
    'margin-top': 'calc(-1 * var(--spacing-medium))'
  },
  nt4: {
    'margin-top': 'calc(-1 * var(--spacing-large))'
  },
  nt5: {
    'margin-top': 'calc(-1 * var(--spacing-extra-large))'
  },
  nt6: {
    'margin-top': 'calc(-1 * var(--spacing-extra-extra-large))'
  },
  nt7: {
    'margin-top': 'calc(-1 * var(--spacing-extra-extra-extra-large))'
  },
  pa0: {
    padding: 'var(--spacing-none)'
  },
  pa1: {
    padding: 'var(--spacing-extra-small)'
  },
  pa2: {
    padding: 'var(--spacing-small)'
  },
  pa3: {
    padding: 'var(--spacing-medium)'
  },
  pa4: {
    padding: 'var(--spacing-large)'
  },
  pa5: {
    padding: 'var(--spacing-extra-large)'
  },
  pa6: {
    padding: 'var(--spacing-extra-extra-large)'
  },
  pa7: {
    padding: 'var(--spacing-extra-extra-extra-large)'
  },
  pl0: {
    'padding-left': 'var(--spacing-none)'
  },
  pl1: {
    'padding-left': 'var(--spacing-extra-small)'
  },
  pl2: {
    'padding-left': 'var(--spacing-small)'
  },
  pl3: {
    'padding-left': 'var(--spacing-medium)'
  },
  pl4: {
    'padding-left': 'var(--spacing-large)'
  },
  pl5: {
    'padding-left': 'var(--spacing-extra-large)'
  },
  pl6: {
    'padding-left': 'var(--spacing-extra-extra-large)'
  },
  pl7: {
    'padding-left': 'var(--spacing-extra-extra-extra-large)'
  },
  pr0: {
    'padding-right': 'var(--spacing-none)'
  },
  pr1: {
    'padding-right': 'var(--spacing-extra-small)'
  },
  pr2: {
    'padding-right': 'var(--spacing-small)'
  },
  pr3: {
    'padding-right': 'var(--spacing-medium)'
  },
  pr4: {
    'padding-right': 'var(--spacing-large)'
  },
  pr5: {
    'padding-right': 'var(--spacing-extra-large)'
  },
  pr6: {
    'padding-right': 'var(--spacing-extra-extra-large)'
  },
  pr7: {
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  },
  pb0: {
    'padding-bottom': 'var(--spacing-none)'
  },
  pb1: {
    'padding-bottom': 'var(--spacing-extra-small)'
  },
  pb2: {
    'padding-bottom': 'var(--spacing-small)'
  },
  pb3: {
    'padding-bottom': 'var(--spacing-medium)'
  },
  pb4: {
    'padding-bottom': 'var(--spacing-large)'
  },
  pb5: {
    'padding-bottom': 'var(--spacing-extra-large)'
  },
  pb6: {
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  },
  pb7: {
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  },
  pt0: {
    'padding-top': 'var(--spacing-none)'
  },
  pt1: {
    'padding-top': 'var(--spacing-extra-small)'
  },
  pt2: {
    'padding-top': 'var(--spacing-small)'
  },
  pt3: {
    'padding-top': 'var(--spacing-medium)'
  },
  pt4: {
    'padding-top': 'var(--spacing-large)'
  },
  pt5: {
    'padding-top': 'var(--spacing-extra-large)'
  },
  pt6: {
    'padding-top': 'var(--spacing-extra-extra-large)'
  },
  pt7: {
    'padding-top': 'var(--spacing-extra-extra-extra-large)'
  },
  pv0: {
    'padding-top': 'var(--spacing-none)',
    'padding-bottom': 'var(--spacing-none)'
  },
  pv1: {
    'padding-top': 'var(--spacing-extra-small)',
    'padding-bottom': 'var(--spacing-extra-small)'
  },
  pv2: {
    'padding-top': 'var(--spacing-small)',
    'padding-bottom': 'var(--spacing-small)'
  },
  pv3: {
    'padding-top': 'var(--spacing-medium)',
    'padding-bottom': 'var(--spacing-medium)'
  },
  pv4: {
    'padding-top': 'var(--spacing-large)',
    'padding-bottom': 'var(--spacing-large)'
  },
  pv5: {
    'padding-top': 'var(--spacing-extra-large)',
    'padding-bottom': 'var(--spacing-extra-large)'
  },
  pv6: {
    'padding-top': 'var(--spacing-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  },
  pv7: {
    'padding-top': 'var(--spacing-extra-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  },
  ph0: {
    'padding-left': 'var(--spacing-none)',
    'padding-right': 'var(--spacing-none)'
  },
  ph1: {
    'padding-left': 'var(--spacing-extra-small)',
    'padding-right': 'var(--spacing-extra-small)'
  },
  ph2: {
    'padding-left': 'var(--spacing-small)',
    'padding-right': 'var(--spacing-small)'
  },
  ph3: {
    'padding-left': 'var(--spacing-medium)',
    'padding-right': 'var(--spacing-medium)'
  },
  ph4: {
    'padding-left': 'var(--spacing-large)',
    'padding-right': 'var(--spacing-large)'
  },
  ph5: {
    'padding-left': 'var(--spacing-extra-large)',
    'padding-right': 'var(--spacing-extra-large)'
  },
  ph6: {
    'padding-left': 'var(--spacing-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-large)'
  },
  ph7: {
    'padding-left': 'var(--spacing-extra-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  },
  ma0: {
    margin: 'var(--spacing-none)'
  },
  ma1: {
    margin: 'var(--spacing-extra-small)'
  },
  ma2: {
    margin: 'var(--spacing-small)'
  },
  ma3: {
    margin: 'var(--spacing-medium)'
  },
  ma4: {
    margin: 'var(--spacing-large)'
  },
  ma5: {
    margin: 'var(--spacing-extra-large)'
  },
  ma6: {
    margin: 'var(--spacing-extra-extra-large)'
  },
  ma7: {
    margin: 'var(--spacing-extra-extra-extra-large)'
  },
  ml0: {
    'margin-left': 'var(--spacing-none)'
  },
  ml1: {
    'margin-left': 'var(--spacing-extra-small)'
  },
  ml2: {
    'margin-left': 'var(--spacing-small)'
  },
  ml3: {
    'margin-left': 'var(--spacing-medium)'
  },
  ml4: {
    'margin-left': 'var(--spacing-large)'
  },
  ml5: {
    'margin-left': 'var(--spacing-extra-large)'
  },
  ml6: {
    'margin-left': 'var(--spacing-extra-extra-large)'
  },
  ml7: {
    'margin-left': 'var(--spacing-extra-extra-extra-large)'
  },
  mr0: {
    'margin-right': 'var(--spacing-none)'
  },
  mr1: {
    'margin-right': 'var(--spacing-extra-small)'
  },
  mr2: {
    'margin-right': 'var(--spacing-small)'
  },
  mr3: {
    'margin-right': 'var(--spacing-medium)'
  },
  mr4: {
    'margin-right': 'var(--spacing-large)'
  },
  mr5: {
    'margin-right': 'var(--spacing-extra-large)'
  },
  mr6: {
    'margin-right': 'var(--spacing-extra-extra-large)'
  },
  mr7: {
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  },
  mb0: {
    'margin-bottom': 'var(--spacing-none)'
  },
  mb1: {
    'margin-bottom': 'var(--spacing-extra-small)'
  },
  mb2: {
    'margin-bottom': 'var(--spacing-small)'
  },
  mb3: {
    'margin-bottom': 'var(--spacing-medium)'
  },
  mb4: {
    'margin-bottom': 'var(--spacing-large)'
  },
  mb5: {
    'margin-bottom': 'var(--spacing-extra-large)'
  },
  mb6: {
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  },
  mb7: {
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  },
  mt0: {
    'margin-top': 'var(--spacing-none)'
  },
  mt1: {
    'margin-top': 'var(--spacing-extra-small)'
  },
  mt2: {
    'margin-top': 'var(--spacing-small)'
  },
  mt3: {
    'margin-top': 'var(--spacing-medium)'
  },
  mt4: {
    'margin-top': 'var(--spacing-large)'
  },
  mt5: {
    'margin-top': 'var(--spacing-extra-large)'
  },
  mt6: {
    'margin-top': 'var(--spacing-extra-extra-large)'
  },
  mt7: {
    'margin-top': 'var(--spacing-extra-extra-extra-large)'
  },
  mv0: {
    'margin-top': 'var(--spacing-none)',
    'margin-bottom': 'var(--spacing-none)'
  },
  mv1: {
    'margin-top': 'var(--spacing-extra-small)',
    'margin-bottom': 'var(--spacing-extra-small)'
  },
  mv2: {
    'margin-top': 'var(--spacing-small)',
    'margin-bottom': 'var(--spacing-small)'
  },
  mv3: {
    'margin-top': 'var(--spacing-medium)',
    'margin-bottom': 'var(--spacing-medium)'
  },
  mv4: {
    'margin-top': 'var(--spacing-large)',
    'margin-bottom': 'var(--spacing-large)'
  },
  mv5: {
    'margin-top': 'var(--spacing-extra-large)',
    'margin-bottom': 'var(--spacing-extra-large)'
  },
  mv6: {
    'margin-top': 'var(--spacing-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  },
  mv7: {
    'margin-top': 'var(--spacing-extra-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  },
  mh0: {
    'margin-left': 'var(--spacing-none)',
    'margin-right': 'var(--spacing-none)'
  },
  mh1: {
    'margin-left': 'var(--spacing-extra-small)',
    'margin-right': 'var(--spacing-extra-small)'
  },
  mh2: {
    'margin-left': 'var(--spacing-small)',
    'margin-right': 'var(--spacing-small)'
  },
  mh3: {
    'margin-left': 'var(--spacing-medium)',
    'margin-right': 'var(--spacing-medium)'
  },
  mh4: {
    'margin-left': 'var(--spacing-large)',
    'margin-right': 'var(--spacing-large)'
  },
  mh5: {
    'margin-left': 'var(--spacing-extra-large)',
    'margin-right': 'var(--spacing-extra-large)'
  },
  mh6: {
    'margin-left': 'var(--spacing-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-large)'
  },
  mh7: {
    'margin-left': 'var(--spacing-extra-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  },
  collapse: {
    'border-collapse': 'collapse',
    'border-spacing': '0'
  },
  'striped--light-gray-nth-child-odd': {
    'background-color': 'var(--light-gray)'
  },
  'striped--near-white-nth-child-odd': {
    'background-color': 'var(--near-white)'
  },
  tl: {
    'text-align': 'left'
  },
  tr: {
    'text-align': 'right'
  },
  tc: {
    'text-align': 'center'
  },
  strike: {
    'text-decoration': 'line-through'
  },
  underline: {
    'text-decoration': 'underline'
  },
  'no-underline': {
    'text-decoration': 'none'
  },
  ttc: {
    'text-transform': 'capitalize'
  },
  ttl: {
    'text-transform': 'lowercase'
  },
  ttu: {
    'text-transform': 'uppercase'
  },
  ttn: {
    'text-transform': 'none'
  },
  'f-6': {
    'font-size': '6rem'
  },
  'f-headline': {
    'font-size': '6rem'
  },
  'f-5': {
    'font-size': '5rem'
  },
  'f-subheadline': {
    'font-size': '5rem'
  },
  f1: {
    'font-size': '3rem'
  },
  f2: {
    'font-size': '2.25rem'
  },
  f3: {
    'font-size': '1.5rem'
  },
  f4: {
    'font-size': '1.25rem'
  },
  f5: {
    'font-size': '1rem'
  },
  f6: {
    'font-size': '.875rem'
  },
  f7: {
    'font-size': '.75rem'
  },
  measure: {
    'max-width': '30em'
  },
  'measure-wide': {
    'max-width': '34em'
  },
  'measure-narrow': {
    'max-width': '20em'
  },
  indent: {
    'text-indent': '1em',
    'margin-top': '0',
    'margin-bottom': '0'
  },
  'small-caps': {
    'font-variant': 'small-caps'
  },
  truncate: {
    'white-space': 'nowrap',
    overflow: 'hidden',
    'text-overflow': 'ellipsis'
  },
  'overflow-container': {
    'overflow-y': 'scroll'
  },
  center: {
    'margin-right': 'auto',
    'margin-left': 'auto'
  },
  'v-base': {
    'vertical-align': 'baseline'
  },
  'v-mid': {
    'vertical-align': 'middle'
  },
  'v-top': {
    'vertical-align': 'top'
  },
  'v-btm': {
    'vertical-align': 'bottom'
  },
  clip: {
    position: 'fixed !important',
    _position: 'absolute !important',
    clip: 'rect(1px, 1px, 1px, 1px)'
  },
  'ws-normal': {
    'white-space': 'normal'
  },
  nowrap: {
    'white-space': 'nowrap'
  },
  w1: {
    width: '1rem'
  },
  w2: {
    width: '2rem'
  },
  w3: {
    width: '4rem'
  },
  w4: {
    width: '8rem'
  },
  w5: {
    width: '16rem'
  },
  'w-10': {
    width: '10%'
  },
  'w-20': {
    width: '20%'
  },
  'w-25': {
    width: '25%'
  },
  'w-30': {
    width: '30%'
  },
  'w-33': {
    width: '33%'
  },
  'w-34': {
    width: '34%'
  },
  'w-40': {
    width: '40%'
  },
  'w-45': {
    width: '45%'
  },
  'w-50': {
    width: '50%'
  },
  'w-55': {
    width: '55%'
  },
  'w-60': {
    width: '60%'
  },
  'w-70': {
    width: '70%'
  },
  'w-75': {
    width: '75%'
  },
  'w-80': {
    width: '80%'
  },
  'w-90': {
    width: '90%'
  },
  'w-100': {
    width: '100%'
  },
  'w-third': {
    width: 'calc(100% / 3)'
  },
  'w-two-thirds': {
    width: 'calc(100% / 1.5)'
  },
  'w-auto': {
    width: 'auto'
  },
  'z-0': {
    'z-index': '0'
  },
  'z-1': {
    'z-index': '1'
  },
  'z-2': {
    'z-index': '2'
  },
  'z-3': {
    'z-index': '3'
  },
  'z-4': {
    'z-index': '4'
  },
  'z-5': {
    'z-index': '5'
  },
  'z-999': {
    'z-index': '999'
  },
  'z-9999': {
    'z-index': '9999'
  },
  'z-max': {
    'z-index': '2147483647'
  },
  'z-inherit': {
    'z-index': 'inherit'
  },
  'z-initial': {
    'z-index': 'initial'
  },
  'z-unset': {
    'z-index': 'unset'
  },
  '--expression--': {
    '@media screen and (min-width: 60em)': '(--breakpoint-large)'
  },
  'aspect-ratio-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '0',
    position: 'relative'
  }),
  'aspect-ratio--16x9-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '56.25%'
  }),
  'aspect-ratio--9x16-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '177.77%'
  }),
  'aspect-ratio--4x3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '75%'
  }),
  'aspect-ratio--3x4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '133.33%'
  }),
  'aspect-ratio--6x4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '66.6%'
  }),
  'aspect-ratio--4x6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '150%'
  }),
  'aspect-ratio--8x5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '62.5%'
  }),
  'aspect-ratio--5x8-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '160%'
  }),
  'aspect-ratio--7x5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '71.42%'
  }),
  'aspect-ratio--5x7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '140%'
  }),
  'aspect-ratio--1x1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': '100%'
  }),
  'aspect-ratio--object-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '100%',
    'z-index': '100'
  }),
  'bg-center-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'background-repeat': 'no-repeat',
    'background-position': 'center center'
  }),
  'bg-top-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'background-repeat': 'no-repeat',
    'background-position': 'top center'
  }),
  'bg-right-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'background-repeat': 'no-repeat',
    'background-position': 'center right'
  }),
  'bg-bottom-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'background-repeat': 'no-repeat',
    'background-position': 'bottom center'
  }),
  'bg-left-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'background-repeat': 'no-repeat',
    'background-position': 'center left'
  }),
  'cover-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'background-size': 'cover'
  }),
  'contain-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'background-size': 'contain'
  }),
  'br0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-radius': '0'
  }),
  'br1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-radius': '.125rem'
  }),
  'br2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-radius': '.25rem'
  }),
  'br3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-radius': '.5rem'
  }),
  'br4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-radius': '1rem'
  }),
  'br-100-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-radius': '100%'
  }),
  'br-pill-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-radius': '9999px'
  }),
  'br--bottom-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-top-left-radius': '0',
    'border-top-right-radius': '0'
  }),
  'br--top-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-bottom-left-radius': '0',
    'border-bottom-right-radius': '0'
  }),
  'br--right-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-top-left-radius': '0',
    'border-bottom-left-radius': '0'
  }),
  'br--left-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-top-right-radius': '0',
    'border-bottom-right-radius': '0'
  }),
  'b--dotted-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-style': 'dotted'
  }),
  'b--dashed-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-style': 'dashed'
  }),
  'b--solid-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-style': 'solid'
  }),
  'b--none-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-style': 'none'
  }),
  'bw0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-width': '0'
  }),
  'bw1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-width': '.125rem'
  }),
  'bw2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-width': '.25rem'
  }),
  'bw3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-width': '.5rem'
  }),
  'bw4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-width': '1rem'
  }),
  'bw5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-width': '2rem'
  }),
  'bt-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-top-width': '0'
  }),
  'br-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-right-width': '0'
  }),
  'bb-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-bottom-width': '0'
  }),
  'bl-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-left-width': '0'
  }),
  'ba-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-style': 'solid',
    'border-width': '1px'
  }),
  'bt-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-top-style': 'solid',
    'border-top-width': '1px'
  }),
  'br-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-right-style': 'solid',
    'border-right-width': '1px'
  }),
  'bb-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-bottom-style': 'solid',
    'border-bottom-width': '1px'
  }),
  'bl-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-left-style': 'solid',
    'border-left-width': '1px'
  }),
  'bn-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'border-style': 'none',
    'border-width': '0'
  }),
  'shadow-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': 'none'
  }),
  'shadow-1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-light-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': 'none'
  }),
  'shadow-light-1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'cl-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    clear: 'left'
  }),
  'cr-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    clear: 'right'
  }),
  'cb-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    clear: 'both'
  }),
  'cn-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    clear: 'none'
  }),
  'top-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    top: '0'
  }),
  'left-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    left: '0'
  }),
  'right-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    right: '0'
  }),
  'bottom-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    bottom: '0'
  }),
  'top-1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    top: '1rem'
  }),
  'left-1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    left: '1rem'
  }),
  'right-1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    right: '1rem'
  }),
  'bottom-1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    bottom: '1rem'
  }),
  'top-2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    top: '2rem'
  }),
  'left-2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    left: '2rem'
  }),
  'right-2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    right: '2rem'
  }),
  'bottom-2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    bottom: '2rem'
  }),
  'top--1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    top: '-1rem'
  }),
  'right--1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    right: '-1rem'
  }),
  'bottom--1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    bottom: '-1rem'
  }),
  'left--1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    left: '-1rem'
  }),
  'top--2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    top: '-2rem'
  }),
  'right--2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    right: '-2rem'
  }),
  'bottom--2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    bottom: '-2rem'
  }),
  'left--2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    left: '-2rem'
  }),
  'absolute--fill-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    top: '0',
    right: '0',
    bottom: '0',
    left: '0'
  }),
  'dn-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'none'
  }),
  'di-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'inline'
  }),
  'db-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'block'
  }),
  'dib-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'inline-block'
  }),
  'dit-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'inline-table'
  }),
  'dt-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'table'
  }),
  'dtc-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'table-cell'
  }),
  'dt-row-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'table-row'
  }),
  'dt-row-group-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'table-row-group'
  }),
  'dt-column-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'table-column'
  }),
  'dt-column-group-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'table-column-group'
  }),
  'dt--fixed-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'table-layout': 'fixed',
    width: '100%'
  }),
  'flex-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'flex'
  }),
  'inline-flex-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    display: 'inline-flex'
  }),
  'flex-auto-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    flex: '1 1 auto',
    'min-width': '0',
    'min-height': '0'
  }),
  'flex-none-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    flex: 'none'
  }),
  'flex-column-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'flex-direction': 'column'
  }),
  'flex-row-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'flex-direction': 'row'
  }),
  'flex-shrink-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'flex-shrink': '0'
  }),
  'flex-wrap-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'flex-wrap': 'wrap'
  }),
  'flex-nowrap-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'flex-wrap': 'nowrap'
  }),
  'items-start-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-items': 'flex-start'
  }),
  'items-end-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-items': 'flex-end'
  }),
  'items-center-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-items': 'center'
  }),
  'items-baseline-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-items': 'baseline'
  }),
  'items-stretch-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-items': 'stretch'
  }),
  'self-start-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-self': 'flex-start'
  }),
  'self-end-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-self': 'flex-end'
  }),
  'self-center-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-self': 'center'
  }),
  'self-baseline-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-self': 'baseline'
  }),
  'self-stretch-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-self': 'stretch'
  }),
  'sticky-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    position: 'sticky'
  }),
  'justify-start-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'justify-content': 'flex-start'
  }),
  'justify-end-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'justify-content': 'flex-end'
  }),
  'justify-center-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'justify-content': 'center'
  }),
  'justify-between-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'justify-content': 'space-between'
  }),
  'justify-around-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'justify-content': 'space-around'
  }),
  'content-start-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-content': 'flex-start'
  }),
  'content-end-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-content': 'flex-end'
  }),
  'content-center-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-content': 'center'
  }),
  'content-between-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-content': 'space-between'
  }),
  'content-around-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-content': 'space-around'
  }),
  'content-stretch-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'align-content': 'stretch'
  }),
  'order-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '0'
  }),
  'order-1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '1'
  }),
  'order-2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '2'
  }),
  'order-3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '3'
  }),
  'order-4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '4'
  }),
  'order-5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '5'
  }),
  'order-6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '6'
  }),
  'order-7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '7'
  }),
  'order-8-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '8'
  }),
  'order-last-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    order: '99999'
  }),
  'fl-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    "float": 'left',
    _display: 'inline'
  }),
  'fr-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    "float": 'right',
    _display: 'inline'
  }),
  'fn-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    "float": 'none'
  }),
  'i-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-style': 'italic'
  }),
  'fs-normal-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-style': 'normal'
  }),
  'normal-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': 'normal'
  }),
  'b-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': 'bold'
  }),
  'fw1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '100'
  }),
  'fw2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '200'
  }),
  'fw3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '300'
  }),
  'fw4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '400'
  }),
  'fw5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '500'
  }),
  'fw6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '600'
  }),
  'fw7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '700'
  }),
  'fw8-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '800'
  }),
  'fw9-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-weight': '900'
  }),
  'h1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '1rem'
  }),
  'h2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '2rem'
  }),
  'h3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '4rem'
  }),
  'h4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '8rem'
  }),
  'h5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '16rem'
  }),
  'h-25-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '25%'
  }),
  'h-50-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '50%'
  }),
  'h-75-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '75%'
  }),
  'h-100-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '100%'
  }),
  'min-h-100-ns': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'min-height': '100%'
  }),
  'vh-25-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '25vh'
  }),
  'vh-50-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '50vh'
  }),
  'vh-75-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '75vh'
  }),
  'vh-100-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: '100vh'
  }),
  'min-vh-100-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'min-height': '100vh'
  }),
  'h-auto-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: 'auto'
  }),
  'h-inherit-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    height: 'inherit'
  }),
  'tracked-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'letter-spacing': '.1em'
  }),
  'tracked-tight-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'letter-spacing': '-.05em'
  }),
  'tracked-mega-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'letter-spacing': '.25em'
  }),
  'lh-solid-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'line-height': '1'
  }),
  'lh-title-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'line-height': '1.25'
  }),
  'lh-copy-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'line-height': '1.5'
  }),
  'mw-100-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '100%'
  }),
  'mw1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '1rem'
  }),
  'mw2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '2rem'
  }),
  'mw3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '4rem'
  }),
  'mw4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '8rem'
  }),
  'mw5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '16rem'
  }),
  'mw6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '32rem'
  }),
  'mw7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '48rem'
  }),
  'mw8-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '64rem'
  }),
  'mw9-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '1440px'
  }),
  'mw-none-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': 'none'
  }),
  'outline-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    outline: '1px solid'
  }),
  'outline-transparent-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    outline: '1px solid transparent'
  }),
  'outline-0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    outline: '0'
  }),
  'overflow-visible-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    overflow: 'visible'
  }),
  'overflow-hidden-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    overflow: 'hidden'
  }),
  'overflow-scroll-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    overflow: 'scroll'
  }),
  'overflow-auto-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    overflow: 'auto'
  }),
  'overflow-x-visible-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'overflow-x': 'visible'
  }),
  'overflow-x-hidden-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'overflow-x': 'hidden'
  }),
  'overflow-x-scroll-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'overflow-x': 'scroll'
  }),
  'overflow-x-auto-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'overflow-x': 'auto'
  }),
  'overflow-y-visible-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'overflow-y': 'visible'
  }),
  'overflow-y-hidden-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'overflow-y': 'hidden'
  }),
  'overflow-y-scroll-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'overflow-y': 'scroll'
  }),
  'overflow-y-auto-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'overflow-y': 'auto'
  }),
  'static-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    position: 'static'
  }),
  'relative-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    position: 'relative'
  }),
  'absolute-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    position: 'absolute'
  }),
  'fixed-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    position: 'fixed'
  }),
  'rotate-45-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    transform: 'rotate(45deg)'
  }),
  'rotate-90-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    transform: 'rotate(90deg)'
  }),
  'rotate-135-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    transform: 'rotate(135deg)'
  }),
  'rotate-180-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    transform: 'rotate(180deg)'
  }),
  'rotate-225-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    transform: 'rotate(225deg)'
  }),
  'rotate-270-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    transform: 'rotate(270deg)'
  }),
  'rotate-315-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    transform: 'rotate(315deg)'
  }),
  'pa0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    padding: 'var(--spacing-none)'
  }),
  'pa1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    padding: 'var(--spacing-extra-small)'
  }),
  'pa2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    padding: 'var(--spacing-small)'
  }),
  'pa3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    padding: 'var(--spacing-medium)'
  }),
  'pa4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    padding: 'var(--spacing-large)'
  }),
  'pa5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    padding: 'var(--spacing-extra-large)'
  }),
  'pa6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    padding: 'var(--spacing-extra-extra-large)'
  }),
  'pa7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    padding: 'var(--spacing-extra-extra-extra-large)'
  }),
  'pl0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-none)'
  }),
  'pl1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-extra-small)'
  }),
  'pl2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-small)'
  }),
  'pl3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-medium)'
  }),
  'pl4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-large)'
  }),
  'pl5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-extra-large)'
  }),
  'pl6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-extra-extra-large)'
  }),
  'pl7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pr0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-right': 'var(--spacing-none)'
  }),
  'pr1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-right': 'var(--spacing-extra-small)'
  }),
  'pr2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-right': 'var(--spacing-small)'
  }),
  'pr3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-right': 'var(--spacing-medium)'
  }),
  'pr4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-right': 'var(--spacing-large)'
  }),
  'pr5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-right': 'var(--spacing-extra-large)'
  }),
  'pr6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-right': 'var(--spacing-extra-extra-large)'
  }),
  'pr7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pb0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': 'var(--spacing-none)'
  }),
  'pb1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': 'var(--spacing-extra-small)'
  }),
  'pb2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': 'var(--spacing-small)'
  }),
  'pb3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': 'var(--spacing-medium)'
  }),
  'pb4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': 'var(--spacing-large)'
  }),
  'pb5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': 'var(--spacing-extra-large)'
  }),
  'pb6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'pb7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pt0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-none)'
  }),
  'pt1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-extra-small)'
  }),
  'pt2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-small)'
  }),
  'pt3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-medium)'
  }),
  'pt4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-large)'
  }),
  'pt5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-extra-large)'
  }),
  'pt6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-extra-extra-large)'
  }),
  'pt7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pv0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-none)',
    'padding-bottom': 'var(--spacing-none)'
  }),
  'pv1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-extra-small)',
    'padding-bottom': 'var(--spacing-extra-small)'
  }),
  'pv2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-small)',
    'padding-bottom': 'var(--spacing-small)'
  }),
  'pv3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-medium)',
    'padding-bottom': 'var(--spacing-medium)'
  }),
  'pv4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-large)',
    'padding-bottom': 'var(--spacing-large)'
  }),
  'pv5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-extra-large)',
    'padding-bottom': 'var(--spacing-extra-large)'
  }),
  'pv6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'pv7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-top': 'var(--spacing-extra-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'ph0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-none)',
    'padding-right': 'var(--spacing-none)'
  }),
  'ph1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-extra-small)',
    'padding-right': 'var(--spacing-extra-small)'
  }),
  'ph2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-small)',
    'padding-right': 'var(--spacing-small)'
  }),
  'ph3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-medium)',
    'padding-right': 'var(--spacing-medium)'
  }),
  'ph4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-large)',
    'padding-right': 'var(--spacing-large)'
  }),
  'ph5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-extra-large)',
    'padding-right': 'var(--spacing-extra-large)'
  }),
  'ph6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-large)'
  }),
  'ph7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'padding-left': 'var(--spacing-extra-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'ma0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    margin: 'var(--spacing-none)'
  }),
  'ma1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    margin: 'var(--spacing-extra-small)'
  }),
  'ma2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    margin: 'var(--spacing-small)'
  }),
  'ma3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    margin: 'var(--spacing-medium)'
  }),
  'ma4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    margin: 'var(--spacing-large)'
  }),
  'ma5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    margin: 'var(--spacing-extra-large)'
  }),
  'ma6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    margin: 'var(--spacing-extra-extra-large)'
  }),
  'ma7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    margin: 'var(--spacing-extra-extra-extra-large)'
  }),
  'ml0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-none)'
  }),
  'ml1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-extra-small)'
  }),
  'ml2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-small)'
  }),
  'ml3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-medium)'
  }),
  'ml4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-large)'
  }),
  'ml5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-extra-large)'
  }),
  'ml6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-extra-extra-large)'
  }),
  'ml7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mr0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-right': 'var(--spacing-none)'
  }),
  'mr1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-right': 'var(--spacing-extra-small)'
  }),
  'mr2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-right': 'var(--spacing-small)'
  }),
  'mr3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-right': 'var(--spacing-medium)'
  }),
  'mr4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-right': 'var(--spacing-large)'
  }),
  'mr5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-right': 'var(--spacing-extra-large)'
  }),
  'mr6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-right': 'var(--spacing-extra-extra-large)'
  }),
  'mr7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mb0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-bottom': 'var(--spacing-none)'
  }),
  'mb1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-bottom': 'var(--spacing-extra-small)'
  }),
  'mb2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-bottom': 'var(--spacing-small)'
  }),
  'mb3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-bottom': 'var(--spacing-medium)'
  }),
  'mb4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-bottom': 'var(--spacing-large)'
  }),
  'mb5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-bottom': 'var(--spacing-extra-large)'
  }),
  'mb6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'mb7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mt0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-none)'
  }),
  'mt1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-extra-small)'
  }),
  'mt2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-small)'
  }),
  'mt3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-medium)'
  }),
  'mt4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-large)'
  }),
  'mt5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-extra-large)'
  }),
  'mt6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-extra-extra-large)'
  }),
  'mt7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mv0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-none)',
    'margin-bottom': 'var(--spacing-none)'
  }),
  'mv1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-extra-small)',
    'margin-bottom': 'var(--spacing-extra-small)'
  }),
  'mv2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-small)',
    'margin-bottom': 'var(--spacing-small)'
  }),
  'mv3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-medium)',
    'margin-bottom': 'var(--spacing-medium)'
  }),
  'mv4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-large)',
    'margin-bottom': 'var(--spacing-large)'
  }),
  'mv5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-extra-large)',
    'margin-bottom': 'var(--spacing-extra-large)'
  }),
  'mv6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'mv7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-top': 'var(--spacing-extra-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mh0-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-none)',
    'margin-right': 'var(--spacing-none)'
  }),
  'mh1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-extra-small)',
    'margin-right': 'var(--spacing-extra-small)'
  }),
  'mh2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-small)',
    'margin-right': 'var(--spacing-small)'
  }),
  'mh3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-medium)',
    'margin-right': 'var(--spacing-medium)'
  }),
  'mh4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-large)',
    'margin-right': 'var(--spacing-large)'
  }),
  'mh5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-extra-large)',
    'margin-right': 'var(--spacing-extra-large)'
  }),
  'mh6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-large)'
  }),
  'mh7-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'margin-left': 'var(--spacing-extra-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'tl-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-align': 'left'
  }),
  'tr-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-align': 'right'
  }),
  'tc-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-align': 'center'
  }),
  'strike-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-decoration': 'line-through'
  }),
  'underline-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-decoration': 'underline'
  }),
  'no-underline-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-decoration': 'none'
  }),
  'ttc-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-transform': 'capitalize'
  }),
  'ttl-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-transform': 'lowercase'
  }),
  'ttu-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-transform': 'uppercase'
  }),
  'ttn-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-transform': 'none'
  }),
  'f-6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '6rem'
  }),
  'f-headline-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '6rem'
  }),
  'f-5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '5rem'
  }),
  'f-subheadline-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '5rem'
  }),
  'f1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '3rem'
  }),
  'f2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '2.25rem'
  }),
  'f3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '1.5rem'
  }),
  'f4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '1.25rem'
  }),
  'f5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '1rem'
  }),
  'f6-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-size': '.875rem'
  }),
  'measure-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '30em'
  }),
  'measure-wide-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '34em'
  }),
  'measure-narrow-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'max-width': '20em'
  }),
  'indent-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'text-indent': '1em',
    'margin-top': '0',
    'margin-bottom': '0'
  }),
  'small-caps-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'font-variant': 'small-caps'
  }),
  'truncate-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'white-space': 'nowrap',
    overflow: 'hidden',
    'text-overflow': 'ellipsis'
  }),
  'v-base-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'vertical-align': 'baseline'
  }),
  'v-mid-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'vertical-align': 'middle'
  }),
  'v-top-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'vertical-align': 'top'
  }),
  'v-btm-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'vertical-align': 'bottom'
  }),
  'clip-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    position: 'fixed !important',
    _position: 'absolute !important',
    clip: 'rect(1px, 1px, 1px, 1px)'
  }),
  'ws-normal-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'white-space': 'normal'
  }),
  'nowrap-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'white-space': 'nowrap'
  }),
  'pre-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    'white-space': 'pre'
  }),
  'w1-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '1rem'
  }),
  'w2-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '2rem'
  }),
  'w3-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '4rem'
  }),
  'w4-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '8rem'
  }),
  'w5-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '16rem'
  }),
  'w-10-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '10%'
  }),
  'w-20-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '20%'
  }),
  'w-25-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '25%'
  }),
  'w-30-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '30%'
  }),
  'w-33-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '33%'
  }),
  'w-34-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '34%'
  }),
  'w-40-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '40%'
  }),
  'w-45-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '45%'
  }),
  'w-50-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '50%'
  }),
  'w-55-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '55%'
  }),
  'w-60-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '60%'
  }),
  'w-70-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '70%'
  }),
  'w-75-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '75%'
  }),
  'w-80-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '80%'
  }),
  'w-90-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '90%'
  }),
  'w-100-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: '100%'
  }),
  'w-third-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: 'calc(100% / 3)'
  }),
  'w-two-thirds-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: 'calc(100% / 1.5)'
  }),
  'w-auto-ns': (0, _defineProperty2["default"])({}, breakpoints.ns, {
    width: 'auto'
  }),
  'aspect-ratio-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '0',
    position: 'relative'
  }),
  'aspect-ratio--16x9-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '56.25%'
  }),
  'aspect-ratio--9x16-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '177.77%'
  }),
  'aspect-ratio--4x3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '75%'
  }),
  'aspect-ratio--3x4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '133.33%'
  }),
  'aspect-ratio--6x4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '66.6%'
  }),
  'aspect-ratio--4x6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '150%'
  }),
  'aspect-ratio--8x5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '62.5%'
  }),
  'aspect-ratio--5x8-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '160%'
  }),
  'aspect-ratio--7x5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '71.42%'
  }),
  'aspect-ratio--5x7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '140%'
  }),
  'aspect-ratio--1x1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': '100%'
  }),
  'aspect-ratio--object-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '100%',
    'z-index': '100'
  }),
  'bg-center-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'background-repeat': 'no-repeat',
    'background-position': 'center center'
  }),
  'bg-top-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'background-repeat': 'no-repeat',
    'background-position': 'top center'
  }),
  'bg-right-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'background-repeat': 'no-repeat',
    'background-position': 'center right'
  }),
  'bg-bottom-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'background-repeat': 'no-repeat',
    'background-position': 'bottom center'
  }),
  'bg-left-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'background-repeat': 'no-repeat',
    'background-position': 'center left'
  }),
  'cover-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'background-size': 'cover'
  }),
  'contain-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'background-size': 'contain'
  }),
  'br0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-radius': '0'
  }),
  'br1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-radius': '.125rem'
  }),
  'br2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-radius': '.25rem'
  }),
  'br3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-radius': '.5rem'
  }),
  'br4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-radius': '1rem'
  }),
  'br-100-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-radius': '100%'
  }),
  'br-pill-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-radius': '9999px'
  }),
  'br--bottom-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-top-left-radius': '0',
    'border-top-right-radius': '0'
  }),
  'br--top-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-bottom-left-radius': '0',
    'border-bottom-right-radius': '0'
  }),
  'br--right-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-top-left-radius': '0',
    'border-bottom-left-radius': '0'
  }),
  'br--left-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-top-right-radius': '0',
    'border-bottom-right-radius': '0'
  }),
  'b--dotted-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-style': 'dotted'
  }),
  'b--dashed-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-style': 'dashed'
  }),
  'b--solid-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-style': 'solid'
  }),
  'b--none-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-style': 'none'
  }),
  'bw0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-width': '0'
  }),
  'bw1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-width': '.125rem'
  }),
  'bw2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-width': '.25rem'
  }),
  'bw3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-width': '.5rem'
  }),
  'bw4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-width': '1rem'
  }),
  'bw5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-width': '2rem'
  }),
  'bt-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-top-width': '0'
  }),
  'br-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-right-width': '0'
  }),
  'bb-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-bottom-width': '0'
  }),
  'bl-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-left-width': '0'
  }),
  'ba-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-style': 'solid',
    'border-width': '1px'
  }),
  'bt-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-top-style': 'solid',
    'border-top-width': '1px'
  }),
  'br-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-right-style': 'solid',
    'border-right-width': '1px'
  }),
  'bb-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-bottom-style': 'solid',
    'border-bottom-width': '1px'
  }),
  'bl-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-left-style': 'solid',
    'border-left-width': '1px'
  }),
  'bn-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'border-style': 'none',
    'border-width': '0'
  }),
  'shadow-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': 'none'
  }),
  'shadow-1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-light-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': 'none'
  }),
  'shadow-light-1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'cl-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    clear: 'left'
  }),
  'cr-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    clear: 'right'
  }),
  'cb-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    clear: 'both'
  }),
  'cn-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    clear: 'none'
  }),
  'top-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    top: '0'
  }),
  'left-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    left: '0'
  }),
  'right-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    right: '0'
  }),
  'bottom-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    bottom: '0'
  }),
  'top-1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    top: '1rem'
  }),
  'left-1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    left: '1rem'
  }),
  'right-1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    right: '1rem'
  }),
  'bottom-1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    bottom: '1rem'
  }),
  'top-2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    top: '2rem'
  }),
  'left-2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    left: '2rem'
  }),
  'right-2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    right: '2rem'
  }),
  'bottom-2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    bottom: '2rem'
  }),
  'top--1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    top: '-1rem'
  }),
  'right--1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    right: '-1rem'
  }),
  'bottom--1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    bottom: '-1rem'
  }),
  'left--1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    left: '-1rem'
  }),
  'top--2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    top: '-2rem'
  }),
  'right--2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    right: '-2rem'
  }),
  'bottom--2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    bottom: '-2rem'
  }),
  'left--2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    left: '-2rem'
  }),
  'absolute--fill-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    top: '0',
    right: '0',
    bottom: '0',
    left: '0'
  }),
  'dn-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'none'
  }),
  'di-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'inline'
  }),
  'db-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'block'
  }),
  'dib-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'inline-block'
  }),
  'dit-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'inline-table'
  }),
  'dt-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'table'
  }),
  'dtc-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'table-cell'
  }),
  'dt-row-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'table-row'
  }),
  'dt-row-group-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'table-row-group'
  }),
  'dt-column-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'table-column'
  }),
  'dt-column-group-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'table-column-group'
  }),
  'dt--fixed-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'table-layout': 'fixed',
    width: '100%'
  }),
  'flex-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'flex'
  }),
  'inline-flex-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    display: 'inline-flex'
  }),
  'flex-auto-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    flex: '1 1 auto',
    'min-width': '0',
    'min-height': '0'
  }),
  'flex-none-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    flex: 'none'
  }),
  'flex-column-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'flex-direction': 'column'
  }),
  'flex-row-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'flex-direction': 'row'
  }),
  'flex-shrink-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'flex-shrink': '0'
  }),
  'flex-wrap-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'flex-wrap': 'wrap'
  }),
  'flex-nowrap-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'flex-wrap': 'nowrap'
  }),
  'items-start-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-items': 'flex-start'
  }),
  'items-end-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-items': 'flex-end'
  }),
  'items-center-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-items': 'center'
  }),
  'items-baseline-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-items': 'baseline'
  }),
  'items-stretch-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-items': 'stretch'
  }),
  'self-start-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-self': 'flex-start'
  }),
  'self-end-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-self': 'flex-end'
  }),
  'self-center-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-self': 'center'
  }),
  'self-baseline-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-self': 'baseline'
  }),
  'self-stretch-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-self': 'stretch'
  }),
  'sticky-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    position: 'sticky'
  }),
  'justify-start-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'justify-content': 'flex-start'
  }),
  'justify-end-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'justify-content': 'flex-end'
  }),
  'justify-center-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'justify-content': 'center'
  }),
  'justify-between-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'justify-content': 'space-between'
  }),
  'justify-around-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'justify-content': 'space-around'
  }),
  'content-start-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-content': 'flex-start'
  }),
  'content-end-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-content': 'flex-end'
  }),
  'content-center-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-content': 'center'
  }),
  'content-between-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-content': 'space-between'
  }),
  'content-around-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-content': 'space-around'
  }),
  'content-stretch-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'align-content': 'stretch'
  }),
  'order-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '0'
  }),
  'order-1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '1'
  }),
  'order-2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '2'
  }),
  'order-3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '3'
  }),
  'order-4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '4'
  }),
  'order-5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '5'
  }),
  'order-6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '6'
  }),
  'order-7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '7'
  }),
  'order-8-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '8'
  }),
  'order-last-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    order: '99999'
  }),
  'fl-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    "float": 'left',
    _display: 'inline'
  }),
  'fr-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    "float": 'right',
    _display: 'inline'
  }),
  'fn-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    "float": 'none'
  }),
  'i-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-style': 'italic'
  }),
  'fs-normal-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-style': 'normal'
  }),
  'normal-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': 'normal'
  }),
  'b-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': 'bold'
  }),
  'fw1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '100'
  }),
  'fw2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '200'
  }),
  'fw3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '300'
  }),
  'fw4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '400'
  }),
  'fw5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '500'
  }),
  'fw6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '600'
  }),
  'fw7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '700'
  }),
  'fw8-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '800'
  }),
  'fw9-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-weight': '900'
  }),
  'h1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '1rem'
  }),
  'h2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '2rem'
  }),
  'h3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '4rem'
  }),
  'h4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '8rem'
  }),
  'h5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '16rem'
  }),
  'h-25-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '25%'
  }),
  'h-50-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '50%'
  }),
  'h-75-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '75%'
  }),
  'h-100-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '100%'
  }),
  'vh-25-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '25vh'
  }),
  'vh-50-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '50vh'
  }),
  'vh-75-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '75vh'
  }),
  'vh-100-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: '100vh'
  }),
  'min-vh-100-m': {
    '@media screen and (min-width: 60em)': {
      'min-height': '100vh'
    }
  },
  'h-auto-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: 'auto'
  }),
  'h-inherit-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    height: 'inherit'
  }),
  'tracked-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'letter-spacing': '.1em'
  }),
  'tracked-tight-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'letter-spacing': '-.05em'
  }),
  'tracked-mega-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'letter-spacing': '.25em'
  }),
  'lh-solid-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'line-height': '1'
  }),
  'lh-title-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'line-height': '1.25'
  }),
  'lh-copy-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'line-height': '1.5'
  }),
  'mw-100-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '100%'
  }),
  'mw1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '1rem'
  }),
  'mw2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '2rem'
  }),
  'mw3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '4rem'
  }),
  'mw4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '8rem'
  }),
  'mw5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '16rem'
  }),
  'mw6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '32rem'
  }),
  'mw7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '48rem'
  }),
  'mw8-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '64rem'
  }),
  'mw9-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '1440px'
  }),
  'mw-none-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': 'none'
  }),
  'outline-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    outline: '1px solid'
  }),
  'outline-transparent-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    outline: '1px solid transparent'
  }),
  'outline-0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    outline: '0'
  }),
  'outline-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    outline: '1px solid'
  }),
  'outline-transparent-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    outline: '1px solid transparent'
  }),
  'outline-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    outline: '0'
  }),
  'overflow-visible-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    overflow: 'visible'
  }),
  'overflow-hidden-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    overflow: 'hidden'
  }),
  'overflow-scroll-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    overflow: 'scroll'
  }),
  'overflow-auto-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    overflow: 'auto'
  }),
  'overflow-x-visible-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'overflow-x': 'visible'
  }),
  'overflow-x-hidden-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'overflow-x': 'hidden'
  }),
  'overflow-x-scroll-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'overflow-x': 'scroll'
  }),
  'overflow-x-auto-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'overflow-x': 'auto'
  }),
  'overflow-y-visible-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'overflow-y': 'visible'
  }),
  'overflow-y-hidden-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'overflow-y': 'hidden'
  }),
  'overflow-y-scroll-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'overflow-y': 'scroll'
  }),
  'overflow-y-auto-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'overflow-y': 'auto'
  }),
  'static-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    position: 'static'
  }),
  'relative-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    position: 'relative'
  }),
  'absolute-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    position: 'absolute'
  }),
  'fixed-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    position: 'fixed'
  }),
  'rotate-45-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    transform: 'rotate(45deg)'
  }),
  'rotate-90-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    transform: 'rotate(90deg)'
  }),
  'rotate-135-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    transform: 'rotate(135deg)'
  }),
  'rotate-180-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    transform: 'rotate(180deg)'
  }),
  'rotate-225-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    transform: 'rotate(225deg)'
  }),
  'rotate-270-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    transform: 'rotate(270deg)'
  }),
  'rotate-315-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    transform: 'rotate(315deg)'
  }),
  'pa0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    padding: 'var(--spacing-none)'
  }),
  'pa1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    padding: 'var(--spacing-extra-small)'
  }),
  'pa2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    padding: 'var(--spacing-small)'
  }),
  'pa3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    padding: 'var(--spacing-medium)'
  }),
  'pa4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    padding: 'var(--spacing-large)'
  }),
  'pa5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    padding: 'var(--spacing-extra-large)'
  }),
  'pa6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    padding: 'var(--spacing-extra-extra-large)'
  }),
  'pa7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    padding: 'var(--spacing-extra-extra-extra-large)'
  }),
  'pl0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-none)'
  }),
  'pl1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-extra-small)'
  }),
  'pl2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-small)'
  }),
  'pl3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-medium)'
  }),
  'pl4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-large)'
  }),
  'pl5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-extra-large)'
  }),
  'pl6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-extra-extra-large)'
  }),
  'pl7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pr0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-right': 'var(--spacing-none)'
  }),
  'pr1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-right': 'var(--spacing-extra-small)'
  }),
  'pr2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-right': 'var(--spacing-small)'
  }),
  'pr3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-right': 'var(--spacing-medium)'
  }),
  'pr4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-right': 'var(--spacing-large)'
  }),
  'pr5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-right': 'var(--spacing-extra-large)'
  }),
  'pr6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-right': 'var(--spacing-extra-extra-large)'
  }),
  'pr7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pb0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': 'var(--spacing-none)'
  }),
  'pb1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': 'var(--spacing-extra-small)'
  }),
  'pb2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': 'var(--spacing-small)'
  }),
  'pb3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': 'var(--spacing-medium)'
  }),
  'pb4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': 'var(--spacing-large)'
  }),
  'pb5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': 'var(--spacing-extra-large)'
  }),
  'pb6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'pb7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pt0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-none)'
  }),
  'pt1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-extra-small)'
  }),
  'pt2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-small)'
  }),
  'pt3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-medium)'
  }),
  'pt4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-large)'
  }),
  'pt5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-extra-large)'
  }),
  'pt6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-extra-extra-large)'
  }),
  'pt7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pv0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-none)',
    'padding-bottom': 'var(--spacing-none)'
  }),
  'pv1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-extra-small)',
    'padding-bottom': 'var(--spacing-extra-small)'
  }),
  'pv2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-small)',
    'padding-bottom': 'var(--spacing-small)'
  }),
  'pv3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-medium)',
    'padding-bottom': 'var(--spacing-medium)'
  }),
  'pv4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-large)',
    'padding-bottom': 'var(--spacing-large)'
  }),
  'pv5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-extra-large)',
    'padding-bottom': 'var(--spacing-extra-large)'
  }),
  'pv6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'pv7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-top': 'var(--spacing-extra-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'ph0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-none)',
    'padding-right': 'var(--spacing-none)'
  }),
  'ph1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-extra-small)',
    'padding-right': 'var(--spacing-extra-small)'
  }),
  'ph2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-small)',
    'padding-right': 'var(--spacing-small)'
  }),
  'ph3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-medium)',
    'padding-right': 'var(--spacing-medium)'
  }),
  'ph4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-large)',
    'padding-right': 'var(--spacing-large)'
  }),
  'ph5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-extra-large)',
    'padding-right': 'var(--spacing-extra-large)'
  }),
  'ph6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-large)'
  }),
  'ph7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'padding-left': 'var(--spacing-extra-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'ma0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    margin: 'var(--spacing-none)'
  }),
  'ma1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    margin: 'var(--spacing-extra-small)'
  }),
  'ma2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    margin: 'var(--spacing-small)'
  }),
  'ma3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    margin: 'var(--spacing-medium)'
  }),
  'ma4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    margin: 'var(--spacing-large)'
  }),
  'ma5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    margin: 'var(--spacing-extra-large)'
  }),
  'ma6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    margin: 'var(--spacing-extra-extra-large)'
  }),
  'ma7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    margin: 'var(--spacing-extra-extra-extra-large)'
  }),
  'ml0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-none)'
  }),
  'ml1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-extra-small)'
  }),
  'ml2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-small)'
  }),
  'ml3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-medium)'
  }),
  'ml4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-large)'
  }),
  'ml5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-extra-large)'
  }),
  'ml6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-extra-extra-large)'
  }),
  'ml7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mr0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-right': 'var(--spacing-none)'
  }),
  'mr1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-right': 'var(--spacing-extra-small)'
  }),
  'mr2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-right': 'var(--spacing-small)'
  }),
  'mr3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-right': 'var(--spacing-medium)'
  }),
  'mr4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-right': 'var(--spacing-large)'
  }),
  'mr5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-right': 'var(--spacing-extra-large)'
  }),
  'mr6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-right': 'var(--spacing-extra-extra-large)'
  }),
  'mr7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mb0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-bottom': 'var(--spacing-none)'
  }),
  'mb1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-bottom': 'var(--spacing-extra-small)'
  }),
  'mb2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-bottom': 'var(--spacing-small)'
  }),
  'mb3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-bottom': 'var(--spacing-medium)'
  }),
  'mb4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-bottom': 'var(--spacing-large)'
  }),
  'mb5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-bottom': 'var(--spacing-extra-large)'
  }),
  'mb6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'mb7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mt0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-none)'
  }),
  'mt1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-extra-small)'
  }),
  'mt2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-small)'
  }),
  'mt3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-medium)'
  }),
  'mt4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-large)'
  }),
  'mt5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-extra-large)'
  }),
  'mt6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-extra-extra-large)'
  }),
  'mt7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mv0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-none)',
    'margin-bottom': 'var(--spacing-none)'
  }),
  'mv1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-extra-small)',
    'margin-bottom': 'var(--spacing-extra-small)'
  }),
  'mv2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-small)',
    'margin-bottom': 'var(--spacing-small)'
  }),
  'mv3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-medium)',
    'margin-bottom': 'var(--spacing-medium)'
  }),
  'mv4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-large)',
    'margin-bottom': 'var(--spacing-large)'
  }),
  'mv5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-extra-large)',
    'margin-bottom': 'var(--spacing-extra-large)'
  }),
  'mv6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'mv7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-top': 'var(--spacing-extra-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mh0-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-none)',
    'margin-right': 'var(--spacing-none)'
  }),
  'mh1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-extra-small)',
    'margin-right': 'var(--spacing-extra-small)'
  }),
  'mh2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-small)',
    'margin-right': 'var(--spacing-small)'
  }),
  'mh3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-medium)',
    'margin-right': 'var(--spacing-medium)'
  }),
  'mh4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-large)',
    'margin-right': 'var(--spacing-large)'
  }),
  'mh5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-extra-large)',
    'margin-right': 'var(--spacing-extra-large)'
  }),
  'mh6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-large)'
  }),
  'mh7-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'margin-left': 'var(--spacing-extra-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'tl-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-align': 'left'
  }),
  'tr-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-align': 'right'
  }),
  'tc-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-align': 'center'
  }),
  'strike-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-decoration': 'line-through'
  }),
  'underline-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-decoration': 'underline'
  }),
  'no-underline-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-decoration': 'none'
  }),
  'ttc-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-transform': 'capitalize'
  }),
  'ttl-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-transform': 'lowercase'
  }),
  'ttu-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-transform': 'uppercase'
  }),
  'ttn-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-transform': 'none'
  }),
  'f-6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '6rem'
  }),
  'f-headline-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '6rem'
  }),
  'f-5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '5rem'
  }),
  'f-subheadline-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '5rem'
  }),
  'f1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '3rem'
  }),
  'f2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '2.25rem'
  }),
  'f3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '1.5rem'
  }),
  'f4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '1.25rem'
  }),
  'f5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '1rem'
  }),
  'f6-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-size': '.875rem'
  }),
  'measure-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '30em'
  }),
  'measure-wide-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '34em'
  }),
  'measure-narrow-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'max-width': '20em'
  }),
  'indent-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'text-indent': '1em',
    'margin-top': '0',
    'margin-bottom': '0'
  }),
  'small-caps-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'font-variant': 'small-caps'
  }),
  'truncate-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'white-space': 'nowrap',
    overflow: 'hidden',
    'text-overflow': 'ellipsis'
  }),
  'v-base-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'vertical-align': 'baseline'
  }),
  'v-mid-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'vertical-align': 'middle'
  }),
  'v-top-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'vertical-align': 'top'
  }),
  'v-btm-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'vertical-align': 'bottom'
  }),
  'clip-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    position: 'fixed !important',
    _position: 'absolute !important',
    clip: 'rect(1px, 1px, 1px, 1px)'
  }),
  'ws-normal-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'white-space': 'normal'
  }),
  'nowrap-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'white-space': 'nowrap'
  }),
  'pre-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    'white-space': 'pre'
  }),
  'w1-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '1rem'
  }),
  'w2-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '2rem'
  }),
  'w3-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '4rem'
  }),
  'w4-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '8rem'
  }),
  'w5-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '16rem'
  }),
  'w-10-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '10%'
  }),
  'w-20-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '20%'
  }),
  'w-25-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '25%'
  }),
  'w-30-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '30%'
  }),
  'w-33-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '33%'
  }),
  'w-34-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '34%'
  }),
  'w-40-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '40%'
  }),
  'w-45-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '45%'
  }),
  'w-50-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '50%'
  }),
  'w-55-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '55%'
  }),
  'w-60-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '60%'
  }),
  'w-70-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '70%'
  }),
  'w-75-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '75%'
  }),
  'w-80-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '80%'
  }),
  'w-90-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '90%'
  }),
  'w-100-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: '100%'
  }),
  'w-third-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: 'calc(100% / 3)'
  }),
  'w-two-thirds-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: 'calc(100% / 1.5)'
  }),
  'w-auto-m': (0, _defineProperty2["default"])({}, breakpoints.m, {
    width: 'auto'
  }),
  'aspect-ratio-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '0',
    position: 'relative'
  }),
  'aspect-ratio--16x9-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '56.25%'
  }),
  'aspect-ratio--9x16-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '177.77%'
  }),
  'aspect-ratio--4x3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '75%'
  }),
  'aspect-ratio--3x4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '133.33%'
  }),
  'aspect-ratio--6x4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '66.6%'
  }),
  'aspect-ratio--4x6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '150%'
  }),
  'aspect-ratio--8x5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '62.5%'
  }),
  'aspect-ratio--5x8-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '160%'
  }),
  'aspect-ratio--7x5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '71.42%'
  }),
  'aspect-ratio--5x7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '140%'
  }),
  'aspect-ratio--1x1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': '100%'
  }),
  'aspect-ratio--object-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '100%',
    'z-index': '100'
  }),
  'bg-center-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'background-repeat': 'no-repeat',
    'background-position': 'center center'
  }),
  'bg-top-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'background-repeat': 'no-repeat',
    'background-position': 'top center'
  }),
  'bg-right-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'background-repeat': 'no-repeat',
    'background-position': 'center right'
  }),
  'bg-bottom-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'background-repeat': 'no-repeat',
    'background-position': 'bottom center'
  }),
  'bg-left-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'background-repeat': 'no-repeat',
    'background-position': 'center left'
  }),
  'cover-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'background-size': 'cover'
  }),
  'contain-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'background-size': 'contain'
  }),
  'br0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-radius': '0'
  }),
  'br1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-radius': '.125rem'
  }),
  'br2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-radius': '.25rem'
  }),
  'br3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-radius': '.5rem'
  }),
  'br4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-radius': '1rem'
  }),
  'br-100-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-radius': '100%'
  }),
  'br-pill-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-radius': '9999px'
  }),
  'br--bottom-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-top-left-radius': '0',
    'border-top-right-radius': '0'
  }),
  'br--top-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-bottom-left-radius': '0',
    'border-bottom-right-radius': '0'
  }),
  'br--right-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-top-left-radius': '0',
    'border-bottom-left-radius': '0'
  }),
  'br--left-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-top-right-radius': '0',
    'border-bottom-right-radius': '0'
  }),
  'b--dotted-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-style': 'dotted'
  }),
  'b--dashed-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-style': 'dashed'
  }),
  'b--solid-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-style': 'solid'
  }),
  'b--none-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-style': 'none'
  }),
  'bw0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-width': '0'
  }),
  'bw1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-width': '.125rem'
  }),
  'bw2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-width': '.25rem'
  }),
  'bw3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-width': '.5rem'
  }),
  'bw4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-width': '1rem'
  }),
  'bw5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-width': '2rem'
  }),
  'bt-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-top-width': '0'
  }),
  'br-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-right-width': '0'
  }),
  'bb-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-bottom-width': '0'
  }),
  'bl-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-left-width': '0'
  }),
  'ba-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-style': 'solid',
    'border-width': '1px'
  }),
  'bt-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-top-style': 'solid',
    'border-top-width': '1px'
  }),
  'br-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-right-style': 'solid',
    'border-right-width': '1px'
  }),
  'bb-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-bottom-style': 'solid',
    'border-bottom-width': '1px'
  }),
  'bl-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-left-style': 'solid',
    'border-left-width': '1px'
  }),
  'bn-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'border-style': 'none',
    'border-width': '0'
  }),
  'shadow-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': 'none'
  }),
  'shadow-1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-light-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': 'none'
  }),
  'shadow-light-1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'cl-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    clear: 'left'
  }),
  'cr-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    clear: 'right'
  }),
  'cb-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    clear: 'both'
  }),
  'cn-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    clear: 'none'
  }),
  'top-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    top: '0'
  }),
  'left-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    left: '0'
  }),
  'right-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    right: '0'
  }),
  'bottom-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    bottom: '0'
  }),
  'top-1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    top: '1rem'
  }),
  'left-1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    left: '1rem'
  }),
  'right-1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    right: '1rem'
  }),
  'bottom-1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    bottom: '1rem'
  }),
  'top-2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    top: '2rem'
  }),
  'left-2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    left: '2rem'
  }),
  'right-2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    right: '2rem'
  }),
  'bottom-2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    bottom: '2rem'
  }),
  'top--1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    top: '-1rem'
  }),
  'right--1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    right: '-1rem'
  }),
  'bottom--1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    bottom: '-1rem'
  }),
  'left--1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    left: '-1rem'
  }),
  'top--2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    top: '-2rem'
  }),
  'right--2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    right: '-2rem'
  }),
  'bottom--2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    bottom: '-2rem'
  }),
  'left--2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    left: '-2rem'
  }),
  'absolute--fill-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    top: '0',
    right: '0',
    bottom: '0',
    left: '0'
  }),
  'dn-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'none'
  }),
  'di-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'inline'
  }),
  'db-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'block'
  }),
  'dib-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'inline-block'
  }),
  'dit-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'inline-table'
  }),
  'dt-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'table'
  }),
  'dtc-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'table-cell'
  }),
  'dt-row-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'table-row'
  }),
  'dt-row-group-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'table-row-group'
  }),
  'dt-column-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'table-column'
  }),
  'dt-column-group-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'table-column-group'
  }),
  'dt--fixed-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'table-layout': 'fixed',
    width: '100%'
  }),
  'flex-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'flex'
  }),
  'inline-flex-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    display: 'inline-flex'
  }),
  'flex-auto-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    flex: '1 1 auto',
    'min-width': '0',
    'min-height': '0'
  }),
  'flex-none-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    flex: 'none'
  }),
  'flex-column-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'flex-direction': 'column'
  }),
  'flex-row-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'flex-direction': 'row'
  }),
  'flex-shrink-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'flex-shrink': '0'
  }),
  'flex-wrap-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'flex-wrap': 'wrap'
  }),
  'flex-nowrap-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'flex-wrap': 'nowrap'
  }),
  'items-start-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-items': 'flex-start'
  }),
  'items-end-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-items': 'flex-end'
  }),
  'items-center-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-items': 'center'
  }),
  'items-baseline-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-items': 'baseline'
  }),
  'items-stretch-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-items': 'stretch'
  }),
  'self-start-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-self': 'flex-start'
  }),
  'self-end-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-self': 'flex-end'
  }),
  'self-center-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-self': 'center'
  }),
  'self-baseline-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-self': 'baseline'
  }),
  'self-stretch-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-self': 'stretch'
  }),
  'sticky-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    position: 'sticky'
  }),
  'justify-start-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'justify-content': 'flex-start'
  }),
  'justify-end-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'justify-content': 'flex-end'
  }),
  'justify-center-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'justify-content': 'center'
  }),
  'justify-between-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'justify-content': 'space-between'
  }),
  'justify-around-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'justify-content': 'space-around'
  }),
  'content-start-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-content': 'flex-start'
  }),
  'content-end-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-content': 'flex-end'
  }),
  'content-center-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-content': 'center'
  }),
  'content-between-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-content': 'space-between'
  }),
  'content-around-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-content': 'space-around'
  }),
  'content-stretch-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'align-content': 'stretch'
  }),
  'order-0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '0'
  }),
  'order-1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '1'
  }),
  'order-2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '2'
  }),
  'order-3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '3'
  }),
  'order-4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '4'
  }),
  'order-5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '5'
  }),
  'order-6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '6'
  }),
  'order-7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '7'
  }),
  'order-8-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '8'
  }),
  'order-last-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    order: '99999'
  }),
  'fl-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    "float": 'left',
    _display: 'inline'
  }),
  'fr-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    "float": 'right',
    _display: 'inline'
  }),
  'fn-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    "float": 'none'
  }),
  'i-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-style': 'italic'
  }),
  'fs-normal-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-style': 'normal'
  }),
  'normal-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': 'normal'
  }),
  'b-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': 'bold'
  }),
  'fw1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '100'
  }),
  'fw2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '200'
  }),
  'fw3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '300'
  }),
  'fw4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '400'
  }),
  'fw5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '500'
  }),
  'fw6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '600'
  }),
  'fw7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '700'
  }),
  'fw8-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '800'
  }),
  'fw9-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-weight': '900'
  }),
  'h1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '1rem'
  }),
  'h2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '2rem'
  }),
  'h3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '4rem'
  }),
  'h4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '8rem'
  }),
  'h5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '16rem'
  }),
  'h-25-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '25%'
  }),
  'h-50-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '50%'
  }),
  'h-75-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '75%'
  }),
  'h-100-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '100%'
  }),
  'min-h-100-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'min-height': '100%'
  }),
  'vh-25-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '25vh'
  }),
  'vh-50-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '50vh'
  }),
  'vh-75-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '75vh'
  }),
  'vh-100-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: '100vh'
  }),
  'h-auto-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: 'auto'
  }),
  'h-inherit-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    height: 'inherit'
  }),
  'tracked-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'letter-spacing': '.1em'
  }),
  'tracked-tight-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'letter-spacing': '-.05em'
  }),
  'tracked-mega-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'letter-spacing': '.25em'
  }),
  'lh-solid-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'line-height': '1'
  }),
  'lh-title-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'line-height': '1.25'
  }),
  'lh-copy-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'line-height': '1.5'
  }),
  'mw-100-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '100%'
  }),
  'mw1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '1rem'
  }),
  'mw2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '2rem'
  }),
  'mw3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '4rem'
  }),
  'mw4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '8rem'
  }),
  'mw5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '16rem'
  }),
  'mw6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '32rem'
  }),
  'mw7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '48rem'
  }),
  'mw8-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '64rem'
  }),
  'mw9-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '1440px'
  }),
  'mw-none-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': 'none'
  }),
  'overflow-visible-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    overflow: 'visible'
  }),
  'overflow-hidden-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    overflow: 'hidden'
  }),
  'overflow-scroll-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    overflow: 'scroll'
  }),
  'overflow-auto-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    overflow: 'auto'
  }),
  'overflow-x-visible-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'overflow-x': 'visible'
  }),
  'overflow-x-hidden-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'overflow-x': 'hidden'
  }),
  'overflow-x-scroll-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'overflow-x': 'scroll'
  }),
  'overflow-x-auto-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'overflow-x': 'auto'
  }),
  'overflow-y-visible-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'overflow-y': 'visible'
  }),
  'overflow-y-hidden-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'overflow-y': 'hidden'
  }),
  'overflow-y-scroll-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'overflow-y': 'scroll'
  }),
  'overflow-y-auto-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'overflow-y': 'auto'
  }),
  'static-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    position: 'static'
  }),
  'relative-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    position: 'relative'
  }),
  'absolute-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    position: 'absolute'
  }),
  'fixed-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    position: 'fixed'
  }),
  'rotate-45-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    transform: 'rotate(45deg)'
  }),
  'rotate-90-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    transform: 'rotate(90deg)'
  }),
  'rotate-135-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    transform: 'rotate(135deg)'
  }),
  'rotate-180-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    transform: 'rotate(180deg)'
  }),
  'rotate-225-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    transform: 'rotate(225deg)'
  }),
  'rotate-270-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    transform: 'rotate(270deg)'
  }),
  'rotate-315-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    transform: 'rotate(315deg)'
  }),
  'pa0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    padding: 'var(--spacing-none)'
  }),
  'pa1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    padding: 'var(--spacing-extra-small)'
  }),
  'pa2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    padding: 'var(--spacing-small)'
  }),
  'pa3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    padding: 'var(--spacing-medium)'
  }),
  'pa4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    padding: 'var(--spacing-large)'
  }),
  'pa5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    padding: 'var(--spacing-extra-large)'
  }),
  'pa6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    padding: 'var(--spacing-extra-extra-large)'
  }),
  'pa7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    padding: 'var(--spacing-extra-extra-extra-large)'
  }),
  'pl0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-none)'
  }),
  'pl1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-extra-small)'
  }),
  'pl2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-small)'
  }),
  'pl3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-medium)'
  }),
  'pl4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-large)'
  }),
  'pl5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-extra-large)'
  }),
  'pl6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-extra-extra-large)'
  }),
  'pl7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pr0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-right': 'var(--spacing-none)'
  }),
  'pr1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-right': 'var(--spacing-extra-small)'
  }),
  'pr2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-right': 'var(--spacing-small)'
  }),
  'pr3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-right': 'var(--spacing-medium)'
  }),
  'pr4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-right': 'var(--spacing-large)'
  }),
  'pr5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-right': 'var(--spacing-extra-large)'
  }),
  'pr6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-right': 'var(--spacing-extra-extra-large)'
  }),
  'pr7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pb0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': 'var(--spacing-none)'
  }),
  'pb1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': 'var(--spacing-extra-small)'
  }),
  'pb2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': 'var(--spacing-small)'
  }),
  'pb3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': 'var(--spacing-medium)'
  }),
  'pb4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': 'var(--spacing-large)'
  }),
  'pb5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': 'var(--spacing-extra-large)'
  }),
  'pb6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'pb7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pt0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-none)'
  }),
  'pt1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-extra-small)'
  }),
  'pt2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-small)'
  }),
  'pt3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-medium)'
  }),
  'pt4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-large)'
  }),
  'pt5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-extra-large)'
  }),
  'pt6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-extra-extra-large)'
  }),
  'pt7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pv0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-none)',
    'padding-bottom': 'var(--spacing-none)'
  }),
  'pv1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-extra-small)',
    'padding-bottom': 'var(--spacing-extra-small)'
  }),
  'pv2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-small)',
    'padding-bottom': 'var(--spacing-small)'
  }),
  'pv3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-medium)',
    'padding-bottom': 'var(--spacing-medium)'
  }),
  'pv4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-large)',
    'padding-bottom': 'var(--spacing-large)'
  }),
  'pv5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-extra-large)',
    'padding-bottom': 'var(--spacing-extra-large)'
  }),
  'pv6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'pv7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-top': 'var(--spacing-extra-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'ph0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-none)',
    'padding-right': 'var(--spacing-none)'
  }),
  'ph1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-extra-small)',
    'padding-right': 'var(--spacing-extra-small)'
  }),
  'ph2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-small)',
    'padding-right': 'var(--spacing-small)'
  }),
  'ph3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-medium)',
    'padding-right': 'var(--spacing-medium)'
  }),
  'ph4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-large)',
    'padding-right': 'var(--spacing-large)'
  }),
  'ph5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-extra-large)',
    'padding-right': 'var(--spacing-extra-large)'
  }),
  'ph6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-large)'
  }),
  'ph7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'padding-left': 'var(--spacing-extra-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'ma0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    margin: 'var(--spacing-none)'
  }),
  'ma1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    margin: 'var(--spacing-extra-small)'
  }),
  'ma2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    margin: 'var(--spacing-small)'
  }),
  'ma3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    margin: 'var(--spacing-medium)'
  }),
  'ma4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    margin: 'var(--spacing-large)'
  }),
  'ma5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    margin: 'var(--spacing-extra-large)'
  }),
  'ma6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    margin: 'var(--spacing-extra-extra-large)'
  }),
  'ma7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    margin: 'var(--spacing-extra-extra-extra-large)'
  }),
  'ml0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-none)'
  }),
  'ml1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-extra-small)'
  }),
  'ml2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-small)'
  }),
  'ml3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-medium)'
  }),
  'ml4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-large)'
  }),
  'ml5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-extra-large)'
  }),
  'ml6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-extra-extra-large)'
  }),
  'ml7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mr0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-right': 'var(--spacing-none)'
  }),
  'mr1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-right': 'var(--spacing-extra-small)'
  }),
  'mr2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-right': 'var(--spacing-small)'
  }),
  'mr3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-right': 'var(--spacing-medium)'
  }),
  'mr4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-right': 'var(--spacing-large)'
  }),
  'mr5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-right': 'var(--spacing-extra-large)'
  }),
  'mr6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-right': 'var(--spacing-extra-extra-large)'
  }),
  'mr7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mb0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-bottom': 'var(--spacing-none)'
  }),
  'mb1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-bottom': 'var(--spacing-extra-small)'
  }),
  'mb2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-bottom': 'var(--spacing-small)'
  }),
  'mb3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-bottom': 'var(--spacing-medium)'
  }),
  'mb4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-bottom': 'var(--spacing-large)'
  }),
  'mb5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-bottom': 'var(--spacing-extra-large)'
  }),
  'mb6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'mb7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mt0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-none)'
  }),
  'mt1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-extra-small)'
  }),
  'mt2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-small)'
  }),
  'mt3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-medium)'
  }),
  'mt4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-large)'
  }),
  'mt5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-extra-large)'
  }),
  'mt6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-extra-extra-large)'
  }),
  'mt7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mv0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-none)',
    'margin-bottom': 'var(--spacing-none)'
  }),
  'mv1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-extra-small)',
    'margin-bottom': 'var(--spacing-extra-small)'
  }),
  'mv2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-small)',
    'margin-bottom': 'var(--spacing-small)'
  }),
  'mv3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-medium)',
    'margin-bottom': 'var(--spacing-medium)'
  }),
  'mv4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-large)',
    'margin-bottom': 'var(--spacing-large)'
  }),
  'mv5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-extra-large)',
    'margin-bottom': 'var(--spacing-extra-large)'
  }),
  'mv6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'mv7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-top': 'var(--spacing-extra-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mh0-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-none)',
    'margin-right': 'var(--spacing-none)'
  }),
  'mh1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-extra-small)',
    'margin-right': 'var(--spacing-extra-small)'
  }),
  'mh2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-small)',
    'margin-right': 'var(--spacing-small)'
  }),
  'mh3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-medium)',
    'margin-right': 'var(--spacing-medium)'
  }),
  'mh4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-large)',
    'margin-right': 'var(--spacing-large)'
  }),
  'mh5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-extra-large)',
    'margin-right': 'var(--spacing-extra-large)'
  }),
  'mh6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-large)'
  }),
  'mh7-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'margin-left': 'var(--spacing-extra-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'tl-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-align': 'left'
  }),
  'tr-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-align': 'right'
  }),
  'tc-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-align': 'center'
  }),
  'strike-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-decoration': 'line-through'
  }),
  'underline-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-decoration': 'underline'
  }),
  'no-underline-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-decoration': 'none'
  }),
  'ttc-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-transform': 'capitalize'
  }),
  'ttl-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-transform': 'lowercase'
  }),
  'ttu-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-transform': 'uppercase'
  }),
  'ttn-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-transform': 'none'
  }),
  'f-6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '6rem'
  }),
  'f-headline-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '6rem'
  }),
  'f-5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '5rem'
  }),
  'f-subheadline-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '5rem'
  }),
  'f1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '3rem'
  }),
  'f2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '2.25rem'
  }),
  'f3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '1.5rem'
  }),
  'f4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '1.25rem'
  }),
  'f5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '1rem'
  }),
  'f6-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-size': '.875rem'
  }),
  'measure-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '30em'
  }),
  'measure-wide-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '34em'
  }),
  'measure-narrow-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'max-width': '20em'
  }),
  'indent-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'text-indent': '1em',
    'margin-top': '0',
    'margin-bottom': '0'
  }),
  'small-caps-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'font-variant': 'small-caps'
  }),
  'truncate-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'white-space': 'nowrap',
    overflow: 'hidden',
    'text-overflow': 'ellipsis'
  }),
  'v-base-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'vertical-align': 'baseline'
  }),
  'v-mid-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'vertical-align': 'middle'
  }),
  'v-top-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'vertical-align': 'top'
  }),
  'v-btm-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'vertical-align': 'bottom'
  }),
  'clip-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    position: 'fixed !important',
    _position: 'absolute !important',
    clip: 'rect(1px, 1px, 1px, 1px)'
  }),
  'ws-normal-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'white-space': 'normal'
  }),
  'nowrap-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'white-space': 'nowrap'
  }),
  'pre-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    'white-space': 'pre'
  }),
  'w1-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '1rem'
  }),
  'w2-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '2rem'
  }),
  'w3-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '4rem'
  }),
  'w4-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '8rem'
  }),
  'w5-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '16rem'
  }),
  'w-10-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '10%'
  }),
  'w-20-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '20%'
  }),
  'w-25-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '25%'
  }),
  'w-30-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '30%'
  }),
  'w-33-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '33%'
  }),
  'w-34-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '34%'
  }),
  'w-40-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '40%'
  }),
  'w-45-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '45%'
  }),
  'w-50-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '50%'
  }),
  'w-55-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '55%'
  }),
  'w-60-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '60%'
  }),
  'w-70-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '70%'
  }),
  'w-75-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '75%'
  }),
  'w-80-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '80%'
  }),
  'w-90-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '90%'
  }),
  'w-100-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: '100%'
  }),
  'w-third-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: 'calc(100% / 3)'
  }),
  'w-two-thirds-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: 'calc(100% / 1.5)'
  }),
  'w-auto-l': (0, _defineProperty2["default"])({}, breakpoints.l, {
    width: 'auto'
  }),
  'aspect-ratio-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '0',
    position: 'relative'
  }),
  'aspect-ratio--16x9-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '56.25%'
  }),
  'aspect-ratio--9x16-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '177.77%'
  }),
  'aspect-ratio--4x3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '75%'
  }),
  'aspect-ratio--3x4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '133.33%'
  }),
  'aspect-ratio--6x4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '66.6%'
  }),
  'aspect-ratio--4x6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '150%'
  }),
  'aspect-ratio--8x5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '62.5%'
  }),
  'aspect-ratio--5x8-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '160%'
  }),
  'aspect-ratio--7x5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '71.42%'
  }),
  'aspect-ratio--5x7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '140%'
  }),
  'aspect-ratio--1x1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': '100%'
  }),
  'aspect-ratio--object-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    width: '100%',
    height: '100%',
    'z-index': '100'
  }),
  'bg-center-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'background-repeat': 'no-repeat',
    'background-position': 'center center'
  }),
  'bg-top-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'background-repeat': 'no-repeat',
    'background-position': 'top center'
  }),
  'bg-right-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'background-repeat': 'no-repeat',
    'background-position': 'center right'
  }),
  'bg-bottom-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'background-repeat': 'no-repeat',
    'background-position': 'bottom center'
  }),
  'bg-left-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'background-repeat': 'no-repeat',
    'background-position': 'center left'
  }),
  'cover-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'background-size': 'cover'
  }),
  'contain-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'background-size': 'contain'
  }),
  'br0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-radius': '0'
  }),
  'br1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-radius': '.125rem'
  }),
  'br2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-radius': '.25rem'
  }),
  'br3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-radius': '.5rem'
  }),
  'br4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-radius': '1rem'
  }),
  'br-100-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-radius': '100%'
  }),
  'br-pill-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-radius': '9999px'
  }),
  'br--bottom-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-top-left-radius': '0',
    'border-top-right-radius': '0'
  }),
  'br--top-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-bottom-left-radius': '0',
    'border-bottom-right-radius': '0'
  }),
  'br--right-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-top-left-radius': '0',
    'border-bottom-left-radius': '0'
  }),
  'br--left-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-top-right-radius': '0',
    'border-bottom-right-radius': '0'
  }),
  'b--dotted-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-style': 'dotted'
  }),
  'b--dashed-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-style': 'dashed'
  }),
  'b--solid-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-style': 'solid'
  }),
  'b--none-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-style': 'none'
  }),
  'bw0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-width': '0'
  }),
  'bw1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-width': '.125rem'
  }),
  'bw2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-width': '.25rem'
  }),
  'bw3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-width': '.5rem'
  }),
  'bw4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-width': '1rem'
  }),
  'bw5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-width': '2rem'
  }),
  'bt-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-top-width': '0'
  }),
  'br-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-right-width': '0'
  }),
  'bb-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-bottom-width': '0'
  }),
  'bl-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-left-width': '0'
  }),
  'ba-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-style': 'solid',
    'border-width': '1px'
  }),
  'bt-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-top-style': 'solid',
    'border-top-width': '1px'
  }),
  'br-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-right-style': 'solid',
    'border-right-width': '1px'
  }),
  'bb-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-bottom-style': 'solid',
    'border-bottom-width': '1px'
  }),
  'bl-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-left-style': 'solid',
    'border-left-width': '1px'
  }),
  'bn-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'border-style': 'none',
    'border-width': '0'
  }),
  'shadow-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': 'none'
  }),
  'shadow-1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.2 )'
  }),
  'shadow-light-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': 'none'
  }),
  'shadow-light-1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '0px 2px 16px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '0px 0px 8px 2px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '2px 2px 4px 2px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '2px 2px 8px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '4px 4px 8px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'shadow-light-6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'box-shadow': '1px 2px 3px 0px rgba( 0, 0, 0, 0.1 )'
  }),
  'cl-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    clear: 'left'
  }),
  'cr-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    clear: 'right'
  }),
  'cb-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    clear: 'both'
  }),
  'cn-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    clear: 'none'
  }),
  'top-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    top: '0'
  }),
  'left-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    left: '0'
  }),
  'right-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    right: '0'
  }),
  'bottom-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    bottom: '0'
  }),
  'top-1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    top: '1rem'
  }),
  'left-1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    left: '1rem'
  }),
  'right-1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    right: '1rem'
  }),
  'bottom-1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    bottom: '1rem'
  }),
  'top-2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    top: '2rem'
  }),
  'left-2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    left: '2rem'
  }),
  'right-2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    right: '2rem'
  }),
  'bottom-2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    bottom: '2rem'
  }),
  'top--1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    top: '-1rem'
  }),
  'right--1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    right: '-1rem'
  }),
  'bottom--1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    bottom: '-1rem'
  }),
  'left--1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    left: '-1rem'
  }),
  'top--2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    top: '-2rem'
  }),
  'right--2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    right: '-2rem'
  }),
  'bottom--2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    bottom: '-2rem'
  }),
  'left--2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    left: '-2rem'
  }),
  'absolute--fill-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    top: '0',
    right: '0',
    bottom: '0',
    left: '0'
  }),
  'dn-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'none'
  }),
  'di-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'inline'
  }),
  'db-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'block'
  }),
  'dib-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'inline-block'
  }),
  'dit-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'inline-table'
  }),
  'dt-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'table'
  }),
  'dtc-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'table-cell'
  }),
  'dt-row-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'table-row'
  }),
  'dt-row-group-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'table-row-group'
  }),
  'dt-column-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'table-column'
  }),
  'dt-column-group-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'table-column-group'
  }),
  'dt--fixed-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'table-layout': 'fixed',
    width: '100%'
  }),
  'flex-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'flex'
  }),
  'inline-flex-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    display: 'inline-flex'
  }),
  'flex-auto-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    flex: '1 1 auto',
    'min-width': '0',
    'min-height': '0'
  }),
  'flex-none-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    flex: 'none'
  }),
  'flex-column-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'flex-direction': 'column'
  }),
  'flex-row-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'flex-direction': 'row'
  }),
  'flex-shrink-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'flex-shrink': '0'
  }),
  'flex-wrap-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'flex-wrap': 'wrap'
  }),
  'flex-nowrap-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'flex-wrap': 'nowrap'
  }),
  'items-start-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-items': 'flex-start'
  }),
  'items-end-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-items': 'flex-end'
  }),
  'items-center-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-items': 'center'
  }),
  'items-baseline-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-items': 'baseline'
  }),
  'items-stretch-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-items': 'stretch'
  }),
  'self-start-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-self': 'flex-start'
  }),
  'self-end-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-self': 'flex-end'
  }),
  'self-center-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-self': 'center'
  }),
  'self-baseline-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-self': 'baseline'
  }),
  'self-stretch-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-self': 'stretch'
  }),
  'sticky-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    position: 'sticky'
  }),
  'justify-start-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'justify-content': 'flex-start'
  }),
  'justify-end-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'justify-content': 'flex-end'
  }),
  'justify-center-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'justify-content': 'center'
  }),
  'justify-between-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'justify-content': 'space-between'
  }),
  'justify-around-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'justify-content': 'space-around'
  }),
  'content-start-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-content': 'flex-start'
  }),
  'content-end-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-content': 'flex-end'
  }),
  'content-center-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-content': 'center'
  }),
  'content-between-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-content': 'space-between'
  }),
  'content-around-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-content': 'space-around'
  }),
  'content-stretch-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'align-content': 'stretch'
  }),
  'order-0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '0'
  }),
  'order-1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '1'
  }),
  'order-2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '2'
  }),
  'order-3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '3'
  }),
  'order-4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '4'
  }),
  'order-5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '5'
  }),
  'order-6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '6'
  }),
  'order-7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '7'
  }),
  'order-8-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '8'
  }),
  'order-last-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    order: '99999'
  }),
  'fl-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    "float": 'left',
    _display: 'inline'
  }),
  'fr-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    "float": 'right',
    _display: 'inline'
  }),
  'fn-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    "float": 'none'
  }),
  'i-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-style': 'italic'
  }),
  'fs-normal-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-style': 'normal'
  }),
  'normal-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': 'normal'
  }),
  'b-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': 'bold'
  }),
  'fw1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '100'
  }),
  'fw2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '200'
  }),
  'fw3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '300'
  }),
  'fw4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '400'
  }),
  'fw5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '500'
  }),
  'fw6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '600'
  }),
  'fw7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '700'
  }),
  'fw8-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '800'
  }),
  'fw9-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-weight': '900'
  }),
  'h1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '1rem'
  }),
  'h2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '2rem'
  }),
  'h3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '4rem'
  }),
  'h4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '8rem'
  }),
  'h5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '16rem'
  }),
  'h-25-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '25%'
  }),
  'h-50-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '50%'
  }),
  'h-75-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '75%'
  }),
  'h-100-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '100%'
  }),
  'min-h-100-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'min-height': '100%'
  }),
  'vh-25-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '25vh'
  }),
  'vh-50-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '50vh'
  }),
  'vh-75-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '75vh'
  }),
  'vh-100-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: '100vh'
  }),
  'h-auto-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: 'auto'
  }),
  'h-inherit-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    height: 'inherit'
  }),
  'tracked-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'letter-spacing': '.1em'
  }),
  'tracked-tight-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'letter-spacing': '-.05em'
  }),
  'tracked-mega-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'letter-spacing': '.25em'
  }),
  'lh-solid-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'line-height': '1'
  }),
  'lh-title-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'line-height': '1.25'
  }),
  'lh-copy-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'line-height': '1.5'
  }),
  'mw-100-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '100%'
  }),
  'mw1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '1rem'
  }),
  'mw2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '2rem'
  }),
  'mw3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '4rem'
  }),
  'mw4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '8rem'
  }),
  'mw5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '16rem'
  }),
  'mw6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '32rem'
  }),
  'mw7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '48rem'
  }),
  'mw8-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '64rem'
  }),
  'mw9-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '1440px'
  }),
  'mw-none-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': 'none'
  }),
  'overflow-visible-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    overflow: 'visible'
  }),
  'overflow-hidden-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    overflow: 'hidden'
  }),
  'overflow-scroll-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    overflow: 'scroll'
  }),
  'overflow-auto-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    overflow: 'auto'
  }),
  'overflow-x-visible-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'overflow-x': 'visible'
  }),
  'overflow-x-hidden-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'overflow-x': 'hidden'
  }),
  'overflow-x-scroll-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'overflow-x': 'scroll'
  }),
  'overflow-x-auto-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'overflow-x': 'auto'
  }),
  'overflow-y-visible-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'overflow-y': 'visible'
  }),
  'overflow-y-hidden-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'overflow-y': 'hidden'
  }),
  'overflow-y-scroll-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'overflow-y': 'scroll'
  }),
  'overflow-y-auto-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'overflow-y': 'auto'
  }),
  'static-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    position: 'static'
  }),
  'relative-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    position: 'relative'
  }),
  'absolute-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    position: 'absolute'
  }),
  'fixed-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    position: 'fixed'
  }),
  'rotate-45-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    transform: 'rotate(45deg)'
  }),
  'rotate-90-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    transform: 'rotate(90deg)'
  }),
  'rotate-135-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    transform: 'rotate(135deg)'
  }),
  'rotate-180-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    transform: 'rotate(180deg)'
  }),
  'rotate-225-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    transform: 'rotate(225deg)'
  }),
  'rotate-270-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    transform: 'rotate(270deg)'
  }),
  'rotate-315-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    transform: 'rotate(315deg)'
  }),
  'pa0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    padding: 'var(--spacing-none)'
  }),
  'pa1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    padding: 'var(--spacing-extra-small)'
  }),
  'pa2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    padding: 'var(--spacing-small)'
  }),
  'pa3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    padding: 'var(--spacing-medium)'
  }),
  'pa4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    padding: 'var(--spacing-large)'
  }),
  'pa5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    padding: 'var(--spacing-extra-large)'
  }),
  'pa6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    padding: 'var(--spacing-extra-extra-large)'
  }),
  'pa7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    padding: 'var(--spacing-extra-extra-extra-large)'
  }),
  'pl0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-none)'
  }),
  'pl1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-extra-small)'
  }),
  'pl2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-small)'
  }),
  'pl3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-medium)'
  }),
  'pl4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-large)'
  }),
  'pl5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-extra-large)'
  }),
  'pl6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-extra-extra-large)'
  }),
  'pl7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pr0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-right': 'var(--spacing-none)'
  }),
  'pr1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-right': 'var(--spacing-extra-small)'
  }),
  'pr2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-right': 'var(--spacing-small)'
  }),
  'pr3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-right': 'var(--spacing-medium)'
  }),
  'pr4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-right': 'var(--spacing-large)'
  }),
  'pr5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-right': 'var(--spacing-extra-large)'
  }),
  'pr6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-right': 'var(--spacing-extra-extra-large)'
  }),
  'pr7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pb0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': 'var(--spacing-none)'
  }),
  'pb1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': 'var(--spacing-extra-small)'
  }),
  'pb2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': 'var(--spacing-small)'
  }),
  'pb3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': 'var(--spacing-medium)'
  }),
  'pb4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': 'var(--spacing-large)'
  }),
  'pb5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': 'var(--spacing-extra-large)'
  }),
  'pb6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'pb7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pt0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-none)'
  }),
  'pt1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-extra-small)'
  }),
  'pt2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-small)'
  }),
  'pt3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-medium)'
  }),
  'pt4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-large)'
  }),
  'pt5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-extra-large)'
  }),
  'pt6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-extra-extra-large)'
  }),
  'pt7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-extra-extra-extra-large)'
  }),
  'pv0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-none)',
    'padding-bottom': 'var(--spacing-none)'
  }),
  'pv1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-extra-small)',
    'padding-bottom': 'var(--spacing-extra-small)'
  }),
  'pv2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-small)',
    'padding-bottom': 'var(--spacing-small)'
  }),
  'pv3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-medium)',
    'padding-bottom': 'var(--spacing-medium)'
  }),
  'pv4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-large)',
    'padding-bottom': 'var(--spacing-large)'
  }),
  'pv5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-extra-large)',
    'padding-bottom': 'var(--spacing-extra-large)'
  }),
  'pv6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'pv7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-top': 'var(--spacing-extra-extra-extra-large)',
    'padding-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'ph0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-none)',
    'padding-right': 'var(--spacing-none)'
  }),
  'ph1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-extra-small)',
    'padding-right': 'var(--spacing-extra-small)'
  }),
  'ph2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-small)',
    'padding-right': 'var(--spacing-small)'
  }),
  'ph3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-medium)',
    'padding-right': 'var(--spacing-medium)'
  }),
  'ph4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-large)',
    'padding-right': 'var(--spacing-large)'
  }),
  'ph5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-extra-large)',
    'padding-right': 'var(--spacing-extra-large)'
  }),
  'ph6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-large)'
  }),
  'ph7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'padding-left': 'var(--spacing-extra-extra-extra-large)',
    'padding-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'ma0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    margin: 'var(--spacing-none)'
  }),
  'ma1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    margin: 'var(--spacing-extra-small)'
  }),
  'ma2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    margin: 'var(--spacing-small)'
  }),
  'ma3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    margin: 'var(--spacing-medium)'
  }),
  'ma4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    margin: 'var(--spacing-large)'
  }),
  'ma5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    margin: 'var(--spacing-extra-large)'
  }),
  'ma6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    margin: 'var(--spacing-extra-extra-large)'
  }),
  'ma7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    margin: 'var(--spacing-extra-extra-extra-large)'
  }),
  'ml0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-none)'
  }),
  'ml1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-extra-small)'
  }),
  'ml2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-small)'
  }),
  'ml3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-medium)'
  }),
  'ml4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-large)'
  }),
  'ml5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-extra-large)'
  }),
  'ml6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-extra-extra-large)'
  }),
  'ml7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mr0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-right': 'var(--spacing-none)'
  }),
  'mr1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-right': 'var(--spacing-extra-small)'
  }),
  'mr2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-right': 'var(--spacing-small)'
  }),
  'mr3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-right': 'var(--spacing-medium)'
  }),
  'mr4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-right': 'var(--spacing-large)'
  }),
  'mr5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-right': 'var(--spacing-extra-large)'
  }),
  'mr6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-right': 'var(--spacing-extra-extra-large)'
  }),
  'mr7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mb0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-bottom': 'var(--spacing-none)'
  }),
  'mb1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-bottom': 'var(--spacing-extra-small)'
  }),
  'mb2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-bottom': 'var(--spacing-small)'
  }),
  'mb3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-bottom': 'var(--spacing-medium)'
  }),
  'mb4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-bottom': 'var(--spacing-large)'
  }),
  'mb5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-bottom': 'var(--spacing-extra-large)'
  }),
  'mb6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'mb7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mt0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-none)'
  }),
  'mt1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-extra-small)'
  }),
  'mt2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-small)'
  }),
  'mt3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-medium)'
  }),
  'mt4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-large)'
  }),
  'mt5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-extra-large)'
  }),
  'mt6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-extra-extra-large)'
  }),
  'mt7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mv0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-none)',
    'margin-bottom': 'var(--spacing-none)'
  }),
  'mv1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-extra-small)',
    'margin-bottom': 'var(--spacing-extra-small)'
  }),
  'mv2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-small)',
    'margin-bottom': 'var(--spacing-small)'
  }),
  'mv3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-medium)',
    'margin-bottom': 'var(--spacing-medium)'
  }),
  'mv4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-large)',
    'margin-bottom': 'var(--spacing-large)'
  }),
  'mv5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-extra-large)',
    'margin-bottom': 'var(--spacing-extra-large)'
  }),
  'mv6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-large)'
  }),
  'mv7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-top': 'var(--spacing-extra-extra-extra-large)',
    'margin-bottom': 'var(--spacing-extra-extra-extra-large)'
  }),
  'mh0-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-none)',
    'margin-right': 'var(--spacing-none)'
  }),
  'mh1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-extra-small)',
    'margin-right': 'var(--spacing-extra-small)'
  }),
  'mh2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-small)',
    'margin-right': 'var(--spacing-small)'
  }),
  'mh3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-medium)',
    'margin-right': 'var(--spacing-medium)'
  }),
  'mh4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-large)',
    'margin-right': 'var(--spacing-large)'
  }),
  'mh5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-extra-large)',
    'margin-right': 'var(--spacing-extra-large)'
  }),
  'mh6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-large)'
  }),
  'mh7-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'margin-left': 'var(--spacing-extra-extra-extra-large)',
    'margin-right': 'var(--spacing-extra-extra-extra-large)'
  }),
  'tl-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-align': 'left'
  }),
  'tr-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-align': 'right'
  }),
  'tc-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-align': 'center'
  }),
  'strike-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-decoration': 'line-through'
  }),
  'underline-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-decoration': 'underline'
  }),
  'no-underline-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-decoration': 'none'
  }),
  'ttc-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-transform': 'capitalize'
  }),
  'ttl-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-transform': 'lowercase'
  }),
  'ttu-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-transform': 'uppercase'
  }),
  'ttn-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-transform': 'none'
  }),
  'f-6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '6rem'
  }),
  'f-headline-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '6rem'
  }),
  'f-5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '5rem'
  }),
  'f-subheadline-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '5rem'
  }),
  'f1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '3rem'
  }),
  'f2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '2.25rem'
  }),
  'f3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '1.5rem'
  }),
  'f4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '1.25rem'
  }),
  'f5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '1rem'
  }),
  'f6-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-size': '.875rem'
  }),
  'measure-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '30em'
  }),
  'measure-wide-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '34em'
  }),
  'measure-narrow-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'max-width': '20em'
  }),
  'indent-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'text-indent': '1em',
    'margin-top': '0',
    'margin-bottom': '0'
  }),
  'small-caps-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'font-variant': 'small-caps'
  }),
  'truncate-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'white-space': 'nowrap',
    overflow: 'hidden',
    'text-overflow': 'ellipsis'
  }),
  'v-base-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'vertical-align': 'baseline'
  }),
  'v-mid-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'vertical-align': 'middle'
  }),
  'v-top-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'vertical-align': 'top'
  }),
  'v-btm-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'vertical-align': 'bottom'
  }),
  'clip-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    position: 'fixed !important',
    _position: 'absolute !important',
    clip: 'rect(1px, 1px, 1px, 1px)'
  }),
  'ws-normal-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'white-space': 'normal'
  }),
  'nowrap-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'white-space': 'nowrap'
  }),
  'pre-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    'white-space': 'pre'
  }),
  'w1-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '1rem'
  }),
  'w2-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '2rem'
  }),
  'w3-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '4rem'
  }),
  'w4-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '8rem'
  }),
  'w5-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '16rem'
  }),
  'w-10-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '10%'
  }),
  'w-20-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '20%'
  }),
  'w-25-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '25%'
  }),
  'w-30-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '30%'
  }),
  'w-33-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '33%'
  }),
  'w-34-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '34%'
  }),
  'w-40-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '40%'
  }),
  'w-45-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '45%'
  }),
  'w-50-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '50%'
  }),
  'w-55-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '55%'
  }),
  'w-60-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '60%'
  }),
  'w-70-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '70%'
  }),
  'w-75-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '75%'
  }),
  'w-80-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '80%'
  }),
  'w-90-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '90%'
  }),
  'w-100-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: '100%'
  }),
  'w-third-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: 'calc(100% / 3)'
  }),
  'w-two-thirds-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: 'calc(100% / 1.5)'
  }),
  'w-auto-xl': (0, _defineProperty2["default"])({}, breakpoints.xl, {
    width: 'auto'
  }),
  ':hover': {
    transition: 'color .15s ease-in'
  },
  'underline-hover': {
    ':hover': {
      'text-decoration': 'underline'
    }
  },
  pointer: {
    ':hover': {
      cursor: 'pointer'
    }
  },
  'c-not': {
    cursor: 'not-allowed'
  },
  pen: {
    'pointer-events': 'none'
  },
  'hover-black': {
    ':hover': {
      color: 'var(--black)'
    }
  },
  'hover-near-black': {
    ':hover': {
      color: 'var(--near-black)'
    }
  },
  'hover-dark-gray': {
    ':hover': {
      color: 'var(--dark-gray)'
    }
  },
  'hover-mid-gray': {
    ':hover': {
      color: 'var(--mid-gray)'
    }
  },
  'hover-gray': {
    ':hover': {
      color: 'var(--gray)'
    }
  },
  'hover-light-gray': {
    ':hover': {
      color: 'var(--light-gray)'
    }
  },
  'hover-near-white': {
    ':hover': {
      color: 'var(--near-white)'
    }
  },
  'hover-white': {
    ':hover': {
      color: 'var(--white)'
    }
  },
  'hover-bg-black': {
    ':hover': {
      'background-color': 'var(--black)'
    }
  },
  'hover-bg-near-black': {
    ':hover': {
      'background-color': 'var(--near-black)'
    }
  },
  'hover-bg-dark-gray': {
    ':hover': {
      'background-color': 'var(--dark-gray)'
    }
  },
  'hover-bg-mid-gray': {
    ':hover': {
      'background-color': 'var(--mid-gray)'
    }
  },
  'hover-bg-gray': {
    ':hover': {
      'background-color': 'var(--gray)'
    }
  },
  'hover-bg-light-gray': {
    ':hover': {
      'background-color': 'var(--light-gray)'
    }
  },
  'hover-bg-near-white': {
    ':hover': {
      'background-color': 'var(--near-white)'
    }
  },
  'hover-bg-white': {
    ':hover': {
      'background-color': 'var(--white)'
    }
  },
  'hover-bg-transparent': {
    ':hover': {
      'background-color': 'var(--transparent)'
    }
  },
  'hover-dark-red': {
    ':hover': {
      color: 'var(--dark-red)'
    }
  },
  'hover-red': {
    ':hover': {
      color: 'var(--red)'
    }
  },
  'hover-light-red': {
    ':hover': {
      color: 'var(--light-red)'
    }
  },
  'hover-orange': {
    ':hover': {
      color: 'var(--orange)'
    }
  },
  'hover-dark-orange': {
    ':hover': {
      color: 'var(--dark-orange)'
    }
  },
  'hover-gold': {
    ':hover': {
      color: 'var(--gold)'
    }
  },
  'hover-yellow': {
    ':hover': {
      color: 'var(--yellow)'
    }
  },
  'hover-light-yellow': {
    ':hover': {
      color: 'var(--light-yellow)'
    }
  },
  'hover-green': {
    ':hover': {
      color: 'var(--green)'
    }
  },
  'hover-light-green': {
    ':hover': {
      color: 'var(--light-green)'
    }
  },
  'hover-navy': {
    ':hover': {
      color: 'var(--navy)'
    }
  },
  'hover-dark-blue': {
    ':hover': {
      color: 'var(--dark-blue)'
    }
  },
  'hover-blue': {
    ':hover': {
      color: 'var(--blue)'
    }
  },
  'hover-light-blue': {
    ':hover': {
      color: 'var(--light-blue)'
    }
  },
  'hover-lightest-blue': {
    ':hover': {
      color: 'var(--lightest-blue)'
    }
  },
  'hover-washed-blue': {
    ':hover': {
      color: 'var(--washed-blue)'
    }
  },
  'hover-bg-dark-red': {
    ':hover': {
      'background-color': 'var(--dark-red)'
    }
  },
  'hover-bg-red': {
    ':hover': {
      'background-color': 'var(--red)'
    }
  },
  'hover-bg-light-red': {
    ':hover': {
      'background-color': 'var(--light-red)'
    }
  },
  'hover-bg-orange': {
    ':hover': {
      'background-color': 'var(--orange)'
    }
  },
  'hover-bg-dark-orange': {
    ':hover': {
      'background-color': 'var(--dark-orange)'
    }
  },
  'hover-bg-gold': {
    ':hover': {
      'background-color': 'var(--gold)'
    }
  },
  'hover-bg-yellow': {
    ':hover': {
      'background-color': 'var(--yellow)'
    }
  },
  'hover-bg-light-yellow': {
    ':hover': {
      'background-color': 'var(--light-yellow)'
    }
  },
  'hover-bg-green': {
    ':hover': {
      'background-color': 'var(--green)'
    }
  },
  'hover-bg-light-green': {
    ':hover': {
      'background-color': 'var(--light-green)'
    }
  },
  'hover-bg-navy': {
    ':hover': {
      'background-color': 'var(--navy)'
    }
  },
  'hover-bg-dark-blue': {
    ':hover': {
      'background-color': 'var(--dark-blue)'
    }
  },
  'hover-bg-blue': {
    ':hover': {
      'background-color': 'var(--blue)'
    }
  },
  'hover-bg-light-blue': {
    ':hover': {
      'background-color': 'var(--light-blue)'
    }
  },
  'hover-bg-lightest-blue': {
    ':hover': {
      'background-color': 'var(--lightest-blue)'
    }
  },
  'hover-bg-washed-blue': {
    ':hover': {
      'background-color': 'var(--washed-blue)'
    }
  }
};
exports["default"] = _default;